
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire11f4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire11f4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3gJDb", function(module, exports) {

$parcel$export(module.exports, "identity", () => $aeb32aab3f19cbf9$export$f0954fd7d5368655);
$parcel$export(module.exports, "wrap", () => $aeb32aab3f19cbf9$export$4997ffc0176396a6);
$parcel$export(module.exports, "void_promise", () => $aeb32aab3f19cbf9$export$7a90e52a324e89a2);
$parcel$export(module.exports, "reduce_sum", () => $aeb32aab3f19cbf9$export$def0c1bcdeb703b8);
$parcel$export(module.exports, "as_tuples", () => $aeb32aab3f19cbf9$export$3549bf827609b016);
$parcel$export(module.exports, "text", () => $aeb32aab3f19cbf9$export$6f093cfa640b7166);
$parcel$export(module.exports, "disable_loading_indicator", () => $aeb32aab3f19cbf9$export$de25300b56fb6cec);
$parcel$export(module.exports, "enable_loading_indicator", () => $aeb32aab3f19cbf9$export$581ce0c8c9a55fd1);
$parcel$export(module.exports, "debounce", () => $aeb32aab3f19cbf9$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "pointer_events", () => $aeb32aab3f19cbf9$export$9f4d51799e979466);
/**
 * A module containing common type definitions
 * and helper functions.
 */ /**
 * Types that can be cloned using `structuredClone()`.
 *
 * This type excludes excludes Wev/API specific types. Not particular reason for this.
 * It was simply a pain to add them all. Feel free to add them as needed.
 *
 * Refer to [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm)
 * for a complete overview.
 *
 * |> Beware that this custom Error types are not allowed in `structuredClone()`
 * |> even if the type says it allows any Error type.
 */ const $aeb32aab3f19cbf9$export$f0954fd7d5368655 = (v)=>v;
const $aeb32aab3f19cbf9$export$4997ffc0176396a6 = (v)=>()=>v;
const $aeb32aab3f19cbf9$export$7a90e52a324e89a2 = (cb)=>{
    return cb;
};
const $aeb32aab3f19cbf9$export$def0c1bcdeb703b8 = (acc, v)=>acc + v;
const $aeb32aab3f19cbf9$export$3549bf827609b016 = (obj)=>Object.keys(obj).map((key)=>[
            key,
            obj[key]
        ]);
function $aeb32aab3f19cbf9$export$6f093cfa640b7166(text, node_type) {
    if (node_type) {
        const node = document.createElement(node_type);
        node.innerText = text;
        return node;
    }
    return document.createTextNode(text);
}
const $aeb32aab3f19cbf9$export$de25300b56fb6cec = ()=>{
    const indicator = document.getElementById('loading-indicator');
    indicator.style.display = 'none';
    indicator.classList.remove('natural-pos');
};
const $aeb32aab3f19cbf9$export$581ce0c8c9a55fd1 = (natural_pos = false)=>{
    const indicator = document.getElementById('loading-indicator');
    indicator.style.display = 'block';
    if (natural_pos) indicator.classList.add('natural-pos');
};
const $aeb32aab3f19cbf9$export$61fc7d43ac8f84b0 = (delay, f)=>{
    let timeout;
    let bounces = 0;
    return (e)=>{
        if (timeout != null) {
            clearTimeout(timeout);
            bounces += 1;
        }
        timeout = setTimeout(()=>{
            f(e, bounces);
            bounces = 0;
            timeout = null;
        }, delay);
    };
};
const $aeb32aab3f19cbf9$export$9f4d51799e979466 = (target, handles)=>{
    let active_pointer;
    let click_handle;
    if ('click' in handles) click_handle = handles['click'];
    if ('n_click' in handles) {
        if (click_handle != null) console.warn('incompatible events given in `pointer_events` (click + n_click)');
        click_handle = $aeb32aab3f19cbf9$export$61fc7d43ac8f84b0(200, handles['n_click']);
    }
    const check_hold = 'hold' in handles;
    let hold_timeout;
    let trigger_release = false;
    target.addEventListener('pointerdown', (e)=>{
        if (handles.stop_propagation === true) e.stopPropagation();
        if (e.button !== 0 || active_pointer != null) return;
        active_pointer = e.pointerId;
        if (check_hold) {
            const [length, handle] = handles.hold;
            hold_timeout = setTimeout(()=>{
                // Setting the active_pointer to null cancels the pointerup event
                active_pointer = null;
                hold_timeout = null;
                handle();
                if (handles.hold.length === 3) trigger_release = true;
            }, length);
        }
    });
    target.addEventListener('pointerup', (e)=>{
        if (e.button === 0 && trigger_release) {
            trigger_release = false;
            handles.hold[2]();
        }
        if (e.button !== 0 || e.pointerId !== active_pointer) return;
        if (hold_timeout != null) {
            clearTimeout(hold_timeout);
            hold_timeout = null;
        }
        if (click_handle != null) click_handle(e);
        active_pointer = null;
    });
    target.addEventListener('pointercancel', (e)=>{
        if (e.pointerId === active_pointer) {
            active_pointer = null;
            if (hold_timeout != null) {
                clearTimeout(hold_timeout);
                hold_timeout = null;
            }
        }
    });
};

});

const $03718d3379a37d9e$export$76e324a9f4eb4867 = true;
function $03718d3379a37d9e$var$read_feature_list() {
    const states = {
        cli_backend: false
    };
    "".split(';').map((value)=>{
        const mode = value.charAt(0);
        if (mode !== '-' && mode !== '+') return null;
        states[value.slice(1)] = mode === '+';
    });
    return states;
}
let $03718d3379a37d9e$var$config = {
    // This uses a cors-proxy (npm run cors-proxy) to add CORS headers
    // to stregsystem requests.
    base_api_url: "http://localhost:8000/api",
    events_api_url: "https://www.googleapis.com/calendar/v3/calendars/",
    events_id: "fke9k8sbuqttoif5ff7ccbb0bc@group.calendar.google.com",
    events_api_key: "AIzaSyBNlYH01_9Hc5S1J9vuFmu2nUqBZJNAXxs",
    events_base_url: "https://calendar.google.com/calendar/u/0/r?cid=",
    default_room: parseInt(undefined) || 1,
    features: $03718d3379a37d9e$var$read_feature_list()
};
var $03718d3379a37d9e$export$2e2bcd8739ae039 = $03718d3379a37d9e$var$config;


/**
 * This module contains several highly unnecessary abstractions
 * for writing asynchronous code. Some more cursed than others.
 * (A few of them may actually be truly useful :) )
 */ /**
 * A module that provides a structure that abstracts transformations
 * over a conditional state. The structure is largely functionally
 * equivalent to a Maybe/Option type. The difference lies primarily
 * in the functions we use to produce and consume the structure.
 *
 * Mostly intended as a foundational structure for the `AsyncConditional` structure,
 * but can be used in a standalone manner.
 *
 * If we ever introduce a proper Maybe/Option type we should consider
 * making this into an alias/newtype of that, filling in gaps as needed.
 */ const $bdb29bc573ff8139$export$4d19a61c80ddc140 = (val)=>new $bdb29bc573ff8139$export$923991e82137deb4(val);
const $bdb29bc573ff8139$export$b885144fe43a6894 = ()=>new $bdb29bc573ff8139$export$fce29daef36d6317();
const $bdb29bc573ff8139$export$7ffafceb12143143 = (predicate, v)=>predicate ? $bdb29bc573ff8139$export$4d19a61c80ddc140(v) : $bdb29bc573ff8139$export$b885144fe43a6894();
const $bdb29bc573ff8139$export$5785073a403f57d8 = (p)=>(i, v)=>$bdb29bc573ff8139$export$7ffafceb12143143(p(i), v);
class $bdb29bc573ff8139$export$923991e82137deb4 {
    val;
    constructor(val){
        this.val = val;
    }
    then_use(v) {
        return $bdb29bc573ff8139$export$4d19a61c80ddc140(v);
    }
    then_map(f) {
        return $bdb29bc573ff8139$export$4d19a61c80ddc140(f(this.val));
    }
    then_if(f) {
        return f(this.val);
    }
    /**
     * Resolves the condition returning the stored value.
     * Note that this is only available for `Truth` so you will need to
     * check the type before trying to call resolve on a `Condition`.
     */ resolve() {
        return this.val;
    }
    else_use(_) {
        return this;
    }
    else_map(f) {
        return this;
    }
    else_if(f) {
        return this;
    }
    is_truth() {
        return true;
    }
    is_falsity() {
        return false;
    }
}
class $bdb29bc573ff8139$export$fce29daef36d6317 {
    then_use(_) {
        return $bdb29bc573ff8139$export$b885144fe43a6894();
    }
    then_if(f) {
        return $bdb29bc573ff8139$export$b885144fe43a6894();
    }
    then_map(f) {
        return $bdb29bc573ff8139$export$b885144fe43a6894();
    }
    else_use(v) {
        return $bdb29bc573ff8139$export$4d19a61c80ddc140(v);
    }
    else_map(f) {
        return $bdb29bc573ff8139$export$4d19a61c80ddc140(f());
    }
    else_if(f) {
        return f();
    }
    is_truth() {
        return false;
    }
    is_falsity() {
        return true;
    }
}



var $3gJDb = parcelRequire("3gJDb");
const $d65da55d02f5d4e6$export$a6d0699925e990d2 = (cond, value, reason)=>cond ? Promise.resolve(value) : Promise.reject(reason);
/**
 * Chains the promise into an `AsyncCondition` using the given predicate
 * and the given value.
 * @param predicate The predicate of the condition.
 * @param cond_val A value or a function producing a value by mapping `T -> U`.
 */ Promise.prototype.if = function(predicate, cond_val) {
    if (typeof cond_val !== "function") cond_val = (0, $3gJDb.wrap)(cond_val);
    return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(this.then((val)=>(0, $bdb29bc573ff8139$export$7ffafceb12143143)(predicate(val), cond_val(val))));
};
class $d65da55d02f5d4e6$export$a7f9e1b495868e85 {
    inner;
    constructor(p){
        this.inner = p;
    }
    then_use(v) {
        return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(this.inner.then((cond)=>cond.then_use(v)));
    }
    then_if(f) {
        return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(this.inner.then((cond)=>cond.then_if(f)));
    }
    then_if_async(f) {
        const { inner: inner } = this;
        const new_inner = this.inner.then((cond)=>cond.then_map((v)=>f(v).inner).else_use(inner.then((cond)=>cond.then_if(()=>(0, $bdb29bc573ff8139$export$b885144fe43a6894)()))).resolve());
        return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(new_inner);
    }
    else_use(v) {
        return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(this.inner.then((cond)=>cond.else_use(v)));
    }
    else_if(f) {
        return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(this.inner.then((cond)=>cond.else_if(f)));
    }
    else_if_async(f) {
        const { inner: inner } = this;
        const new_inner = this.inner.then((cond)=>{
            if (cond.is_falsity()) return f().inner;
            else return inner;
        });
        return new $d65da55d02f5d4e6$export$a7f9e1b495868e85(new_inner);
    }
    else_promise(fallback) {
        return this.inner.then((cond)=>cond.else_use(fallback).resolve());
    }
    else_then_promise(f) {
        return this.inner.then((cond)=>cond.else_map(f).resolve());
    }
}
class $d65da55d02f5d4e6$export$41ed841bd6096947 {
    handles = [];
    id;
    /**
     * @param id An identifier for the event that is used when logging errors.
     */ constructor(id){
        this.id = id;
    }
    /**
     * Register a new event handle that will be called upon event occurrences.
     * @param handle A function that accepts the event information.
     * @param bind_target
     * @param once A boolean flag used to specify that the handle may only be invoked once.
     */ register_handle(handle, bind_target = null, once = false) {
        if (bind_target != null) handle = handle.bind(bind_target);
        this.handles.push({
            once: once,
            fn: handle
        });
    }
    /**
     * Dispatch an event occurrence, invoking the registered handles.
     * @param event The event data.
     */ dispatch(event) {
        for (const handle of this.handles)try {
            handle.fn(event);
            if (handle.once) handle.fn = ()=>void 0;
        } catch (e) {
            console.error(`Error executing dispatch handle for event \`${this.id}\``);
            console.error(e);
        }
    }
}



var $61eff7957713c367$exports = {};

$parcel$export($61eff7957713c367$exports, "get_member_id", () => $61eff7957713c367$export$34b71a1ba293e1b3);
$parcel$export($61eff7957713c367$exports, "get_member_info", () => $61eff7957713c367$export$927d0f2977e8112b);
$parcel$export($61eff7957713c367$exports, "get_member_balance", () => $61eff7957713c367$export$ba899e88c3f6abfc);
$parcel$export($61eff7957713c367$exports, "get_active_products", () => $61eff7957713c367$export$dc7ee5442df48de0);
$parcel$export($61eff7957713c367$exports, "post_sale", () => $61eff7957713c367$export$4973ffe22c18566);
$parcel$export($61eff7957713c367$exports, "init", () => $61eff7957713c367$export$2cd8252107eb640b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


var $1aacde83d5d2495d$exports = {};
$1aacde83d5d2495d$exports = import.meta.resolve("fCxl0");



var $3gJDb = parcelRequire("3gJDb");
let $b22d2393df1c17c8$var$worker;
let $b22d2393df1c17c8$var$init_promise;
/**
 * Flags for ensuring that one time operations, such as
 * patching various libraries, can't be run multiple times.
 */ const $b22d2393df1c17c8$var$flags = {};
/**
 * Object that maps a symbol to a promise resolve function.
 */ const $b22d2393df1c17c8$var$msg_resolvers = {};
/**
 * Throws an error if the python worker has not been initialised.
 * @param call_site
 */ const $b22d2393df1c17c8$var$ensure_init = (call_site)=>{
    if ($b22d2393df1c17c8$var$init_promise == null) throw new Error(`[python_interop] a call to init is required before calling ${call_site.name}`);
};
const $b22d2393df1c17c8$export$2cd8252107eb640b = ()=>{
    if ($b22d2393df1c17c8$var$init_promise != null) return $b22d2393df1c17c8$var$init_promise;
    $b22d2393df1c17c8$var$worker = new Worker((0, (/*@__PURE__*/$parcel$interopDefault($1aacde83d5d2495d$exports))));
    $b22d2393df1c17c8$var$init_promise = new Promise((resolve)=>{
        const _resolve = resolve;
        $b22d2393df1c17c8$var$worker.addEventListener('message', ()=>{
            $b22d2393df1c17c8$var$worker.addEventListener('message', $b22d2393df1c17c8$var$msg_handler);
            _resolve();
        }, {
            once: true
        });
    });
    return $b22d2393df1c17c8$var$init_promise;
};
/**
 * Counter used to assign id for a correspondence.
 */ let $b22d2393df1c17c8$var$run_id_counter = 0;
/**
 * Handles incoming messages from the python worker thread.
 * @param event
 */ const $b22d2393df1c17c8$var$msg_handler = async (event)=>{
    const { id: id, type: type, ...data } = event.data;
    // Handles python -> js calls
    if (type === 'call') {
        const { module: module, method: method, args: args } = event.data;
        const response = {
            type: 'return',
            id: id,
            success: false,
            value: null
        };
        const mod = $b22d2393df1c17c8$var$py_module_list[module];
        if (mod == null || mod[$b22d2393df1c17c8$var$__py_mod_methods] == null) {
            console.error(`[python_interop] invalid call for non-existent module '${module}'`);
            response.value = new Error(`module ${module} not found`);
        } else if (!mod[$b22d2393df1c17c8$var$__py_mod_methods][method]) {
            console.error(`[python_interop] invalid call to non-existent method '${method}' in module '${module}'`);
            response.value = new Error(`method ${method} not found in ${module}`);
        } else try {
            const [fn, serializer] = mod[$b22d2393df1c17c8$var$__py_mod_methods][method];
            response.value = await serializer(fn(args));
            response.success = true;
        } catch (e) {
            response.value = e;
        }
        $b22d2393df1c17c8$var$worker.postMessage(response);
        return;
    }
    const [resolve, reject] = $b22d2393df1c17c8$var$msg_resolvers[id];
    delete $b22d2393df1c17c8$var$msg_resolvers[id];
    if (data.error) reject(data.error);
    else resolve(data);
};
/**
 * Sends a command to the python worker thread. Returns a promise that will
 * be resolved when a response is received.
 * @param type The command that is to run
 * @param params Any parameters that should be sent along
 */ const $b22d2393df1c17c8$var$send_command = (type, params)=>{
    $b22d2393df1c17c8$var$ensure_init($b22d2393df1c17c8$var$send_command);
    const id = $b22d2393df1c17c8$var$run_id_counter = ($b22d2393df1c17c8$var$run_id_counter + 1) % 1000000;
    return new Promise((resolve, reject)=>{
        $b22d2393df1c17c8$var$msg_resolvers[id] = [
            resolve,
            reject
        ];
        params.id = id;
        params.type = type;
        $b22d2393df1c17c8$var$worker.postMessage(params);
        delete params.id;
        delete params.type;
    });
};
const $b22d2393df1c17c8$export$889ea624f2cb2c57 = (code)=>$b22d2393df1c17c8$var$send_command('run', {
        payload: code
    }).then((o)=>o.results);
const $b22d2393df1c17c8$export$4b3e715f166fdd78 = (package_name)=>$b22d2393df1c17c8$var$send_command('install', {
        payload: package_name
    });
const $b22d2393df1c17c8$export$7d2ff54b7dcb1cc8 = (filename, url)=>$b22d2393df1c17c8$var$send_command('run', {
        name: filename,
        url: url
    });
const $b22d2393df1c17c8$export$37932c8884fc6abc = async (module)=>{
    // We don't allow duplicate registration.
    if (module[$b22d2393df1c17c8$var$__py_mod_reg_status]) return;
    module[$b22d2393df1c17c8$var$__py_mod_reg_status] = true;
    const res = await $b22d2393df1c17c8$var$send_command('installJsMod', {
        name: module.py_module_name,
        methods: Object.keys(module[$b22d2393df1c17c8$var$__py_mod_methods])
    });
    module[$b22d2393df1c17c8$var$__py_mod_reg_status] = res.status;
};
/*
    Symbols used to store python module metadata
 */ const $b22d2393df1c17c8$var$__py_mod_methods = Symbol();
const $b22d2393df1c17c8$var$__py_mod_reg_status = Symbol();
const $b22d2393df1c17c8$var$py_module_list = {};
const $b22d2393df1c17c8$var$module_decorator = (module_name)=>(constructor)=>{
        if ($b22d2393df1c17c8$var$py_module_list[module_name] != null) throw new Error(`Python module with name ${module_name} already exists.`);
        class Module extends constructor {
            static [$b22d2393df1c17c8$var$__py_mod_methods] = constructor[$b22d2393df1c17c8$var$__py_mod_methods];
            static [$b22d2393df1c17c8$var$__py_mod_reg_status] = false;
            static get py_module_name() {
                return module_name;
            }
        }
        $b22d2393df1c17c8$var$py_module_list[module_name] = Module;
        return Module;
    };
const $b22d2393df1c17c8$var$method_decorator = (options = {})=>(target, propertyKey, _)=>{
        // If the target is not a function that means the target method
        // is not static. Since only modules are supported all python functions
        // must be static.
        if (!(target instanceof Function)) throw new Error("Cannot use @pyFn on non static class methods");
        if (target[$b22d2393df1c17c8$var$__py_mod_methods] == null) target[$b22d2393df1c17c8$var$__py_mod_methods] = [];
        const method = target[propertyKey];
        if (!(method instanceof Function)) throw new Error("Application of pyMethod decorator on non function member property.");
        const py_name = options.alias || propertyKey;
        if (target[$b22d2393df1c17c8$var$__py_mod_methods][py_name] != null) throw new Error(`Attempt to register duplicate python method ${py_name} in module ${target.name}`);
        target[$b22d2393df1c17c8$var$__py_mod_methods][py_name] = [
            method,
            options.serializer || (0, $3gJDb.identity)
        ];
    };
const $b22d2393df1c17c8$export$f7d8b214031df6ad = $b22d2393df1c17c8$var$module_decorator;
const $b22d2393df1c17c8$export$dd9926908f10141b = $b22d2393df1c17c8$var$method_decorator;


var $30bcbd229619e834$exports = {};
$30bcbd229619e834$exports = "#!/usr/bin/env python3\n# START_STS\nfrom __future__ import print_function, annotations\nimport argparse\nimport builtins as __builtins__\nfrom collections import Counter\nimport configparser\nfrom dataclasses import dataclass\nimport datetime\nfrom datetime import date\nimport importlib.machinery\nimport json\nimport os\nfrom pprint import pprint\nfrom random import random\nimport re\nimport sys\nfrom time import sleep\nimport types\nfrom typing import Callable\n\nimport requests\n\nimport urllib3\n\nurllib3.disable_warnings()\n\nCONSTANTS = {\n    'url': 'https://stregsystem.fklub.dk',\n    'room': '10',\n    'exit_words': [':q', 'exit', 'quit', 'q'],\n    'update_url': 'https://raw.githubusercontent.com/f-klubben/stregsystemet-cli/master/main.py',\n    'plugin_url': 'https://raw.githubusercontent.com/f-klubben/stregsystemet-cli/master/community_plugins/$$REPLACEME$$.py',\n    'debug': False,\n    'printables': {\n        4: '\\U0001F414',  # Chicken emoji\n        10: '\\U0001F987',  # Bat emoji\n        12: '\\U00002744',  # Snowflake emoji\n    },\n}\n\nif sys.argv[0] == './main.py':\n    print('You are running the script in debug mode.')\n    CONSTANTS['url'] = 'http://localhost:8000'\n    CONSTANTS['room'] = '1'\n    CONSTANTS['debug'] = True\n\n\n_date = date.today()\nmonth = _date.month\nbat_amount = _date.day\nlines_counted = 0\n\n# Unicode characters for emojis\n# https://apps.timwhitlock.info/emoji/tables/unicode\nprintables = {\n    4: '\\U0001F414',  # Chicken emoji\n    10: '\\U0001F987',  # Bat emoji\n    12: '\\U00002744',  # Snowflake emoji\n}\n\nspecial_months = [4, 10, 12]\n\nif CONSTANTS['debug']:\n    print(f'MONTH={_date.month}')\n    print(f'PRINTABLE={printables.get(_date.month, \"\")}')\n\n\n# Overwrite of print to write bats and stuff.\ndef print(*args, **kwargs):\n    global bat_amount, lines_counted\n    msg = ' '.join(map(str, args))\n    if _date.month in special_months and bat_amount > 0 and config.getboolean('sts', 'emoji_support', fallback=True):\n        # CPU Heater. Doesn't matter. Still faster than the actual stregsystem\n        print_prob = (\n            ((random() * 10) / (len(' '.join(map(str, args))) * random() + 0.1) * random())\n            * ((_date.day / 100) + 1)\n            * 0.7\n            * (lines_counted * 0.15)\n        )\n        print_prob = print_prob / int(print_prob) if int(print_prob) >= 1 else print_prob\n\n        batted = False\n        for i in range(len(msg)):\n            if print_prob > random() and random() > random() and bat_amount > 0 and not batted:\n                if msg[i] == '-' or msg[i].isdigit():\n                    if random() > 0.04:\n                        print_prob += random()\n                    continue\n                msg = msg[:i] + printables[_date.month] + msg[i + 1 :]\n                bat_amount -= 1\n                batted = True\n                print_prob = print_prob - random()\n                if print_prob <= 0 or bat_amount == 0:\n                    break\n            else:\n                batted = False\n        __builtins__.print(msg, **kwargs)\n    else:\n        __builtins__.print(msg, **kwargs)\n    lines_counted += 1\n\n\ndef calculate_sha256_binary(binary) -> str:\n    import hashlib\n\n    return hashlib.sha256(binary).hexdigest()\n\n\ndef has_version_difference():\n    r = requests.get(CONSTANTS['update_url'])\n    newest_file_hash = calculate_sha256_binary(r.content)\n    with open(__file__, 'rb') as f:\n        data = f.read()\n    current_file_hash = calculate_sha256_binary(data)\n\n    return newest_file_hash != current_file_hash\n\n\ndef update_script():\n    if not os.access(__file__, os.W_OK):\n        print('Stregsystemet-CLI er i læs-kun modus og kan derfor ikke opdateres. Er du på NIX operativsystem?')\n        return\n\n    if not has_version_difference():\n        return\n\n    # I perform open heart surgery on myself :)\n    with open(__file__, 'w', encoding=\"utf-8\") as f:\n        r = requests.get(CONSTANTS['update_url'])\n        if 'START_STS' in r.text and 'END_STS' in r.text:\n            f.write(r.text)\n\n\nclass Configuration:\n    user: str\n    plugin_dir: str\n    emoji_support: bool\n    _dirs = [os.path.expanduser('~/.config/sts/.sts'), os.path.expanduser('~/.sts'), '.sts']\n\n    def __init__(self):\n        try:\n            self.read()\n        except Exception:\n            self.user = ''\n            self.plugin_dir = ''\n            self.emoji_support = False\n\n    def __str__(self):\n        return f'user: {self.user}, plugin_dir: {self.plugin_dir}, emoji_support: {self.emoji_support}'\n\n    def __dict__(self) -> dict:\n        return {'user': self.user, 'plugin_dir': self.plugin_dir, 'emoji_support': self.emoji_support}\n\n    def __repr__(self) -> str:\n        return self.__str__()\n\n    def write(self):\n        paths = [path for path in self._dirs if os.path.exists(path)]\n        config = configparser.ConfigParser()\n        config['sts'] = self.__dict__()\n        with open(paths[0], 'w') as configfile:\n            config.write(configfile)\n\n    def read(self):\n        config = configparser.ConfigParser()\n        config.read(self._dirs)\n        self.user = config['sts']['user']\n        self.plugin_dir = config['sts']['plugin_dir']\n        self.emoji_support = config['sts']['emoji_support'] == 'True'\n\n    def get_user(self):\n        return self.user\n\n    def get_plugin_dir(self):\n        return self.plugin_dir\n\n    def get_emoji_support(self):\n        return self.emoji_support\n\n\nclass History:\n    def __init__(self, date, name, price):\n        self.date = date\n        self.name = name\n        self.price = price\n\n    def __str__(self):\n        return f'{self.date} - {self.name} - {self.price}'\n\n    def __repr__(self):\n        return self.__str__()\n\n    def format_str(self, date_width, name_width, price_width):\n        return f'{self.date:<{date_width}} {self.name:<{name_width}} {self.price:>{price_width}}'\n\n\nclass Product:\n    def __init__(self, id, name, price):\n        self.id = id\n        self.name = name\n        self.special = re.match(r'<\\w+\\d*>', name)\n        self.price = price\n\n    def __repr__(self):\n\n        return f'{self.id} - {self.name} - {self.price}'\n\n    def __str__(self):\n        return f'{self.id} - {self.name} - {self.price}'\n\n    def format_str(self, id_width, name_width, price_width):\n        if re.match(r'<\\w+\\d*>', self.name):\n            self.name = re.sub(r'</?\\w+?\\d*?>', '', self.name)\n            return (\n                f'\\u001B[31m{self.id:<{id_width}} {self.name:<{name_width}} {self.price:>{price_width}.2f} kr.\\u001B[0m'\n            )\n\n        return f'{self.id:<{id_width}} {self.name:<{name_width}} {self.price:>{price_width}.2f} kr.'\n\n    def __getitem__(self, indicies):\n        if indicies == 0:\n            return self.id\n        if indicies == 1:\n            return self.name\n        if indicies == 2:\n            return self.price\n\n\n@dataclass\nclass User:\n    username: str\n    balance: float\n    user_id: int\n\n\n@dataclass\nclass Plugin:\n    pre_argparse: Callable\n    run: Callable\n    post_run: Callable\n\n\ndef parse_split_multibuy(product: str) -> tuple[str, int]:\n    itm: str = product\n    count: str = '1'\n    itm_arr: list[str] = product.split(':')\n    if len(itm_arr) == 2:\n        count = itm_arr[1]\n        itm = itm_arr[0]\n    elif len(itm_arr) > 2:\n        raise SystemExit(\n            f'''Du har fejl i dit multibuy format. Brug kun et : for at adskille antal og vare\nDin fejl er her:\n{product}\n{'~' * (product.index(':', product.index(':') + 1)) + '^'}\n'''\n        )\n    if not re.match(r'\\d+', str(count)):\n        raise SystemExit(\n            f'''Du har fejl i dit multibuy format. Antal skal være et tal\nDin fejl er her:\n{product}\n{('~' * (product.index(':') + 1)) + ('^'*len(str(count)))}\n'''\n        )\n    return itm, int(count)\n\n\nclass Stregsystem:\n    class ArgumentHandler:\n        args: argparse.Namespace\n\n        def __init__(self, args: argparse.Namespace, shorthands: dict[str, int], products: dict[int, Product]):\n            self.args: argparse.Namespace = args\n            self.shorthands: dict[str, int] = shorthands\n\n        def handle_stopping(self, sts: Stregsystem, user_manager, request_handler) -> None:\n            if self.args.update:\n                update_script()\n                raise SystemExit(0)\n            sts.determine_user()\n            if self.args.money:\n                self.mobilepay(self.args.money, user_manager, request_handler)\n                raise SystemExit(0)\n            if self.args.history:\n                self.history(user_manager, request_handler)\n                raise SystemExit(0)\n            if self.args.shorthands:\n                self.show_shorthands()\n                raise SystemExit(0)\n            if self.args.balance:\n                self.balance(user_manager, request_handler)\n                raise SystemExit(0)\n            if self.args.setup:\n                self.setup_sts(user_manager, request_handler, Configuration())\n                raise SystemExit(0)\n            if self.args.rank:\n                self.ranking(user_manager, request_handler)\n                raise SystemExit(0)\n            if self.args.pluginstall:\n                self.install_plugin(self.args.pluginstall, Configuration(), request_handler)\n                raise SystemExit(0)\n            if self.args.pluguninstall:\n                self.uninstall_plugin(self.args.pluguninstall, Configuration())\n                raise SystemExit(0)\n\n        def get_plugin_dir(self, config: Configuration):\n            if config.plugin_dir and os.path.exists(config.plugin_dir):\n                return config.plugin_dir\n\n            # Prompt for setup of plugins. The user wants to install anyways\n            __builtins__.print('You do not have a plugin directory set up.')\n            dirr = input('Please enter a valid plugin directory')\n            while not os.path.exists(dirr):\n                __builtins__.print('You do not have a plugin directory set up.')\n                dirr = input('Please enter a valid plugin directory')\n\n            config.plugin_dir = dirr\n            config.write()\n            return dirr\n\n        def install_plugin(self, plugin_name: str, configuration: Configuration, request_handler: RequestHandler):\n            def test_for_plugin_online(plugin_name: str, request_handler: RequestHandler):\n                req = request_handler.get(CONSTANTS['plugin_url'].replace('$$REPLACEME$$', plugin_name))\n                return req.status_code == 200\n\n            def download_plugin(plugin: str, dirr: str, req_handler: RequestHandler):\n                req = req_handler.get(CONSTANTS['plugin_url'].replace('$$REPLACEME$$', plugin))\n                with open(f'{dirr}{plugin}.py', 'w') as plg:\n                    plg.write(req.text)\n\n            dirr = self.get_plugin_dir(configuration)\n            if test_for_plugin_online(plugin_name, request_handler):\n                existed = os.path.exists(f'{dirr}{plugin_name}.py')\n                download_plugin(plugin_name, dirr, request_handler)\n                print('Plugin', ('installed' if not existed else 'reinstalled'))\n            else:\n                print(f'The plugin \"{plugin_name}\" does not exist as a community plugin.')\n\n        def uninstall_plugin(self, plugin_name: str, configuration: Configuration):\n            dirr = self.get_plugin_dir(configuration)\n            if os.path.exists(f'{dirr}{plugin_name}.py'):\n                os.remove(f'{dirr}{plugin_name}.py')\n                print('Plugin removed')\n            else:\n                print(plugin_name, 'is not an installed plugin')\n\n        def has_products(self) -> bool:\n            return self.args.product is not None and len(self.args.product) > 0\n\n        def history(self, user_manager, request_handler) -> None:\n            hist = user_manager.get_history(request_handler)\n            print('{:<29} {:<40} {:>10}'.format('Date', 'Item', 'Price'))\n            print('-' * 81)\n            for h in hist:\n                print(h.format_str(29, 40, 10))\n\n        def get_products(self) -> dict[str, int]:\n            products = {}\n            for product in self.args.product:\n                itm, count = parse_split_multibuy(product)\n                products[itm] = int(count)\n\n            return products\n\n        def mobilepay(self, amount, user_manager, request_handler) -> None:\n            request_handler.add_funds(amount, user_manager)\n\n        def show_shorthands(self) -> None:\n            sorted_shorthands = {}\n            for i in sorted(self.shorthands):\n                sorted_shorthands[i] = self.shorthands[i]\n            pprint(sorted_shorthands)\n\n        def setup_sts(self, user_manager: UserManager, request_handler: RequestHandler, configuration: Configuration):\n            user = user_manager.get_username()\n            if user is None or not user_manager.check_user_exists(user, request_handler):\n                user = user_manager.prompt_user(request_handler)\n\n            answer = 'a'\n            while answer.lower() not in ['y', 'n']:\n                __builtins__.print('Please check if you are able to see the emojis between the <> symbols below')\n                __builtins__.print(\n                    f'<{CONSTANTS[\"printables\"][4]}><{CONSTANTS[\"printables\"][10]}><{CONSTANTS[\"printables\"][12]}>'\n                )\n                try:\n                    answer = input('Does your terminal support emojis? (y/n) ')\n                except (EOFError, KeyboardInterrupt):\n                    raise SystemExit()\n            emoji_support = answer.lower() == 'y'\n            configuration.user = user\n            configuration.emoji_support = emoji_support\n            configuration.plugin_dir = ''\n            configuration.write()\n\n        def balance(self, user_manager: UserManager, request_handler: RequestHandler) -> None:\n            user = user_manager.get_username()\n            if user is None or not user_manager.check_user_exists(user, request_handler):\n                __builtins__.print('You need to provide a user to check the balance of')\n                raise SystemExit(0)\n            print(user_manager.get_balance())\n\n        def ranking(self, user_manager: UserManager, request_handler: RequestHandler) -> None:\n            user = user_manager.get_username()\n            if user is None or not user_manager.check_user_exists(user, request_handler):\n                __builtins__.print('Ypu need to provide a user to check the ranking of')\n                raise SystemExit()\n            print(user_manager.get_ranking(request_handler))\n\n        def get_user(self):\n            return self.args.user\n\n    class RequestHandler:\n        cookies: dict\n\n        def __init__(self):\n            self.session = requests.Session()\n            self.session.headers.update(\n                {'User-Agent': 'STS - Stregsystem CLI - https://github.com/f-klubben/stregsystemet-cli'}\n            )\n            self.session.headers.update({'Referer': CONSTANTS['url']})\n            self.session.verify = False\n\n        def get(self, url, params=None) -> requests.Response:\n            return self.session.get(url, params=params)\n\n        def get_clean_body(self, response) -> str:\n            return re.sub(r'\\s{2,}', '', response.text)\n\n        def set_cookies(self) -> None:\n            response = self.get(f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/')\n            self.cookies = {'csrftoken': response.cookies.get_dict()['csrftoken'], 'djdt': 'show'}\n\n        def get_token(self, get_response) -> str:\n            token = re.search('(?<=name=\"csrfmiddlewaretoken\" value=\")(.+?)\"', get_response.text)\n            if token:\n                return token.group(1)\n            else:\n                raise Exception('Could not find token in GET request from ' + get_response.url)\n\n        def post(self, url, data=None) -> requests.Response:\n            token = self.get_token(self.get(f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/'))\n            data.update({'csrfmiddlewaretoken': token})\n            return self.session.post(url, data=data)\n\n        def add_funds(self, amount, user_manager) -> None:\n            try:\n                amount = float(amount)\n            except ValueError:\n                raise SystemExit('Det indtastede beløb er ikke et tal')\n            if amount < 50:\n                print('Mindste indsætningsbeløb er 50. Alt under, håndteres ikke.')\n                raise SystemExit(0)\n\n            user = user_manager.get_username()\n            if not user:\n                user = user_manager.prompt_user(self)\n            if not user:\n                raise SystemExit(1)\n\n            print(\"Skan QR koden nedenfor, for at indsætte penge på din stregkonto\")\n            # Start a new session to not leak information about STS to outside host\n            session = requests.Session()\n            r = session.get(f\"https://qrcode.show/mobilepay://send?phone=90601&comment={user}&amount={int(amount)}\")\n            if r.status_code != 200:\n                print('Noget gik galt', r.status_code)\n                if CONSTANTS.get('debug', False):\n                    __builtins__.print(r.content)\n                raise SystemExit\n\n            print(r.content.decode('UTF-8'))\n\n    class UserManager:\n        user: User\n\n        def __init__(self, user) -> None:\n            self.user = user\n\n        def get_user(self) -> User:\n            return self.user\n\n        def update_balance(self, request_handler: RequestHandler) -> None:\n            user_response = request_handler.post(\n                f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/sale/', data={'quickbuy': self.user.username}\n            )\n\n            balance_regex = re.search(r'(\\d+.\\d+) kroner til gode!', user_response.text)\n            if not balance_regex:\n                raise SystemExit(f'Could not get user information from stregsystemet, could not find balance')\n\n            self.user.balance = float(balance_regex.group(1))\n\n        def get_balance(self) -> float:\n            return self.user.balance\n\n        def get_user_id(self) -> int:\n            return self.user.user_id\n\n        def get_username(self) -> str:\n            return self.user.username\n\n        def set_user(self, username, request_handler) -> None:\n            user_response = request_handler.post(\n                f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/sale/', data={'quickbuy': username}\n            )\n            if user_response.status_code != 200:\n                raise SystemExit(\n                    f'Could not get user information from stregsystemet, status {user_response.status_code}'\n                )\n\n            balance_regex = re.search(r'(\\d+.\\d+) kroner til gode!', user_response.text)\n            if not balance_regex:\n                raise SystemExit(f'Could not get user information from stregsystemet, could not find balance')\n\n            balance = float(balance_regex.group(1))\n            user_id_regex = re.search(r'\\<a href=\"/' + CONSTANTS['room'] + '/user/(\\d+)\"', user_response.text)\n            if not user_id_regex:\n                raise SystemExit(f'Could not get user information from stregsystemet, could not find user id')\n\n            user_id = int(user_id_regex.group(1))\n            self.user = User(username, balance, user_id)\n\n        def update_user(self, request_handler) -> None:\n            if not self.user:\n                raise SystemExit('No user set')\n            self.set_user(self.user.username, request_handler)\n\n        def get_history(self, request_handler: RequestHandler) -> list[History]:\n            if not self.user.user_id:\n                print('Den angivne bruger har ikke noget ID. Afslutter')\n                raise SystemExit(1)\n\n            body = request_handler.get_clean_body(\n                request_handler.get(f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/user/{self.user.user_id}/')\n            )\n            item_date_list = re.findall(r'<td>(\\d+\\.\\s\\w+\\s\\d+\\s\\d+:\\d+)</td>', body)\n            item_name_list = [\n                x for x in re.findall(r'<td>(.+?)</td>', body) if x not in item_date_list and '<center>' not in x\n            ][0 : len(item_date_list)]\n            item_price_list = re.findall(r'<td align=\"right\">(\\d+\\.\\d+)</td>', body)\n            history: list[History] = []\n            for x in range(len(item_date_list)):\n                history.append(History(item_date_list[x], item_name_list[x][0:40], f\"{item_price_list[x]} kr\"))\n\n            return history\n\n        def check_user_exists(self, username: str, request_handler: RequestHandler) -> bool:\n            if username == '' or username is None:\n                return False\n            user_response = request_handler.post(\n                f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/sale/', data={'quickbuy': username}\n            )\n            return (\n                user_response.status_code == 200\n                and 'Det lader ikke til, at du er registreret som aktivt medlem af F-klubben' not in user_response.text\n            )\n\n        def prompt_user(self, request_handler: RequestHandler) -> tuple[str, list[str]]:\n            try:\n                response = input('Indtast dit brugernavn: ')\n                while not self.check_user_exists(response.split(' ')[0], request_handler):\n                    self.print_no_user_help(response.split(' ')[0])\n                    response = input('Indtast dit brugernavn: ')\n            except (EOFError, KeyboardInterrupt):\n                raise SystemExit()\n            username = response.split(' ')[0]\n            wares = response.split(' ')[1:]\n            return username, wares\n\n        def print_no_user_help(self, user):\n            print(\n                f'Det var sært, {user}. \\nDet lader ikke til, at du er registreret som aktivt medlem af F-klubben i TREOENs dat'\n                f'abase. \\nMåske tastede du forkert? \\nHvis du ikke er medlem, kan du blive det ved at følge guiden på fklub.dk'\n            )\n\n        def get_ranking(self, request_handler: RequestHandler):\n            ret_val = f'Ranking for {self.user.username}\\n\\n'\n            if not self.user.user_id:\n                ret_val += 'den angivne bruger har ikke noget ID. Afslutter\\n'\n                raise SystemExit(1)\n            r = request_handler.get(f\"{CONSTANTS['url']}/{CONSTANTS['room']}/user/{self.get_user_id()}/rank\")\n            if r.status_code != 200:\n                __builtins__.print('Noget gik galt.', r.status_code, r.url)\n                raise SystemExit(r.status_code)\n            items = self.parse_scoreboard(r.text)\n            ret_val += '{:<20} {:>10} {:>10}'.format('Navn', 'Gennemsnit', 'Rank') + '\\n'\n            ret_val += ('-' * 42) + '\\n'\n            for i in range(len(items[0])):\n                ret_val += self.format_scoreboard((items[0][i], items[1][i], items[2][i])) + '\\n'\n            return ret_val\n\n        def parse_scoreboard(self, content):\n            content = (\n                re.search(r'<table class=\"ranking\">(.+?)</table>', content, re.DOTALL)\n                .group(1)\n                .replace('  ', '')\n                .replace('\\n', '')\n            )\n            headers = re.findall(r'<th class=\"ranking\">(.+?)</th>', content)\n            fields = re.findall(r'<td class=\"ranking\">(.+?)</td>', content)\n            return headers, fields[len(headers) :], fields[: len(headers)]\n\n        def format_scoreboard(self, triple) -> str:\n            return '{:<20} {:>10} {:>10}'.format(*triple)\n\n    products: dict[int, Product] = {}\n    shorthands: dict[str, int] = {}\n    _request_handler: RequestHandler = RequestHandler()\n    _user_manager: UserManager = UserManager(User(username='', balance=0, user_id=0))\n    _argument_handler: ArgumentHandler\n    plugins: list[Plugin] = []\n    kiosk_mode: bool = False\n    disable_plugins: bool = False\n    _args: argparse.Namespace\n    args: argparse.Namespace\n    raw_args: list = []\n\n    config: Configuration\n\n    def __init__(self, config: Configuration, _args: argparse.Namespace, args: list) -> None:\n        if sys.platform == 'win32':\n            os.system('color')\n        self.raw_args = args\n        self.kiosk_mode = _args.strandvejen if _args else False\n        self.disable_plugins = _args.noplugins or self.kiosk_mode if _args else False\n        self._args = _args\n        self.config = config\n\n    def load(self) -> None:\n\n        self.load_plugins()\n        self.update_products()\n        self.update_shorthands()\n\n        parser = argparse.ArgumentParser()\n        if not self.disable_plugins:\n            for plugin in self.plugins:\n                if plugin.pre_argparse:\n                    plugin.pre_argparse(parser, CONSTANTS)\n        self.args = parse(self.raw_args, parser)\n        self._argument_handler = self.ArgumentHandler(self.args, self.shorthands, self.products)\n        self._argument_handler.handle_stopping(self, self._user_manager, self._request_handler)\n\n    def check_user_exists(self, username) -> bool:\n        return self._user_manager.check_user_exists(username, self._request_handler)\n\n    def load_plugins(self) -> None:\n        self.set_plugins(self.get_plugins(self.config))\n\n    def set_plugins(self, plugins: list[Plugin]) -> None:\n        self.plugins = plugins\n\n    def get_plugins(self, config: Configuration) -> list[Plugin]:\n        plugins = []\n        if self.disable_plugins:\n            return plugins\n\n        if config.get_plugin_dir() and os.path.exists(config.get_plugin_dir()):\n            try:\n                for item in [\n                    f'{config.get_plugin_dir()}{item}'\n                    for item in os.listdir(config.get_plugin_dir())\n                    if os.path.isfile(f'{config.get_plugin_dir()}{item}')\n                    and item.endswith('.py')\n                    and item != '__init__.py'\n                ]:\n                    loader = importlib.machinery.SourceFileLoader(item.replace('.py', ''), item)\n                    mod = types.ModuleType(loader.name)\n                    loader.exec_module(mod)\n                    plugins.append(Plugin(mod.pre_argparse, mod.run, mod.post_run))\n            except Exception as e:\n                if e and CONSTANTS['debug']:\n                    print(e)\n                elif not self.kiosk_mode:\n                    print('Der opstod en fejl under indlæsning af plugins. Ingen plugins er blevet indlæst.')\n                plugins = []\n\n        return plugins\n\n    def prompt_user(self) -> tuple[str, list[str]]:\n        return self._user_manager.prompt_user(self._request_handler)\n\n    def make_purchase(self, products: dict[str, int]) -> tuple[bool, str]:\n        # key is item ID, value is quantity\n        output = ''\n        if not self.products:\n            raise SystemExit('Unable to make purchase. No products loaded.')\n\n        sale_output_template = \"\"\"{0} har købt {1} {2} til {3} kr. stykket.\nDer er {4:.2f} stregdollar - eller {5} x {2} tilbage.\n\"\"\"\n        buy_string = f'{self._user_manager.get_username()} '\n        self._user_manager.update_user(self._request_handler)\n        temp_balance = self._user_manager.get_balance()\n        for product_id, quantity in products.items():\n            if quantity < 1:\n                output = f'Du kan ikke købe 0 eller færre varer.\\nDu forsøgte at købe {quantity} x {product_id}'\n                return False, output\n\n            if not re.match(r'\\d+', product_id):\n                if product_id == '':\n                    continue\n                if product_id in self.shorthands:\n                    product_id = self.shorthands[product_id]\n                else:\n                    raise SystemExit(f'Product {product_id} not found.')\n\n            product_id = int(product_id)\n            if product_id not in self.products:\n\n                raise SystemExit(f'Product {product_id} not found.')\n\n            temp_balance -= self.products[product_id].price * quantity\n            itm_units_left = (\n                f\"{(temp_balance / self.products[product_id].price):.2f}\"\n                if self.products[product_id].price > 0\n                else \"∞\"\n            )\n            output += sale_output_template.format(\n                self._user_manager.get_username(),\n                quantity,\n                self.products[product_id].name,\n                self.products[product_id].price,\n                temp_balance,\n                itm_units_left,\n            )\n            buy_string += f'{product_id}:{quantity} '\n\n        response = self._request_handler.post(\n            f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/sale/', data={'quickbuy': buy_string}\n        )\n\n        if 'STREGFORBUD!' in response.text:\n            output = f'''STREGFORBUD!\nDu kan ikke foretage køb, før du har foretaget en indbetaling!\nDu kan foretage indbetaling via MobilePay. Du har {self._user_manager.get_balance()} stregdollars til gode.'''\n\n            return False, output\n\n        self._user_manager.update_user(self._request_handler)\n\n        return response.status_code == 200, output\n\n    def set_user(self, username: str) -> None:\n        self._user_manager.set_user(username, self._request_handler)\n\n    def add_product(self, id, name, price) -> None:\n        self.products[int(id)] = Product(id, name, price)\n\n    def add_shorthand(self, id, shorthand) -> None:\n        self.shorthands[shorthand] = id\n\n    def write_shorthand_file(self, file_path, date) -> None:\n        with open(file_path, 'w') as f:\n            f.writelines([str(date) + '\\n', str(self.shorthands)])\n\n    def read_shorthand_file(self, file_path) -> tuple[datetime.datetime, dict]:\n        with open(file_path, 'r') as f:\n            date = datetime.datetime.fromisoformat(f.readline().strip())\n            self.shorthands = json.loads(f.readline().replace('\\'', '\"'))\n            return date, self.shorthands\n\n    def determine_user(self):\n        if self._argument_handler.get_user():\n            self._user_manager.set_user(self._argument_handler.get_user(), self._request_handler)\n        elif not sts.check_user_exists(configuration.get_user()):\n            username, wares = sts.prompt_user()\n            sts.set_user(username)\n            if wares:\n                sts.buy_multiple_items(wares)\n                sts.handle_kiosk()\n                raise SystemExit\n        else:\n            sts.set_user(configuration.get_user())\n\n    def get_greeting(self, user: User) -> str:\n        return (\n            f'''\nHej, {user.username}\nDu har {user.balance} stregdollar.\n        '''.strip()\n            + '\\n'\n        )\n\n    def get_catalogue(self) -> str:\n        if not self.products:\n            raise SystemExit('No products loaded.')\n        output = '{:<8} {:<50} {:>10}'.format('Id', 'Navn', 'Pris')\n        output += '\\n' + ('-' * 74) + '\\n'\n        output += '\\n'.join([product.format_str(8, 50, 10) for product in self.products.values()])\n        return output\n\n    def update_shorthands(self) -> None:\n        try:\n            if not os.path.exists(os.path.expanduser('~/.sts-wares')):\n                self.shorthands.update(\n                    json.loads(self._request_handler.get(f'{CONSTANTS[\"url\"]}/api/products/named_products').text)\n                )\n                time = datetime.datetime.now()\n                self.write_shorthand_file(os.path.expanduser('~/.sts-wares'), time)\n            else:\n                last_update, _ = self.read_shorthand_file(os.path.expanduser('~/.sts-wares'))\n                if last_update + datetime.timedelta(days=7) < datetime.datetime.now():\n                    if CONSTANTS['debug']:\n                        print('Updating SHORTHANDS')\n                    self.shorthands.update(\n                        json.loads(self._request_handler.get(f'{CONSTANTS[\"url\"]}/api/products/named_products').text)\n                    )\n                    date_ = datetime.datetime.now()\n                    self.write_shorthand_file(os.path.expanduser('~/.sts-wares'), date_)\n        except Exception as e:\n            if CONSTANTS['debug']:\n                __builtins__.print(e)\n            __builtins__.print('FATAL ERROR: Could not fetch shorthands. Shorthands will be disabled for this session')\n\n    def update_products(self) -> None:\n        response = self._request_handler.get(f'{CONSTANTS[\"url\"]}/{CONSTANTS[\"room\"]}/')\n        clean_body = self._request_handler.get_clean_body(response)\n        item_id_list = re.findall(r'<td>(\\d+)( / \\w+)?</td>', clean_body)\n        item_name_list = re.findall(r'<td>(.+?)</td>', clean_body)\n        item_price_list = re.findall(r'<td align=\"right\">(\\d+\\.\\d+) kr</td>', clean_body)\n\n        exclusion_set = set([f'{y[0]}{y[1]}' for y in item_id_list])\n        item_name_list = [\n            x.replace('<br>', ' - ')\n            for x in item_name_list\n            if x not in exclusion_set and (re.match(r'<\\w+\\d+>', x) is not None or not x.startswith('<'))\n        ]\n\n        for i in range(len(item_id_list)):\n            self.add_product(item_id_list[i][0], item_name_list[i], float(item_price_list[i]))\n\n    def quickbuy(self, items=None) -> None:\n        if items is None:\n            success, output = self.make_purchase(self._argument_handler.get_products())\n        else:\n            success, output = self.make_purchase(items)\n        print(output)\n        if not self.disable_plugins:\n            for plugin in self.plugins:\n                if plugin.post_run:\n                    plugin.post_run(\n                        list(self.products.values()),\n                        self._argument_handler.args,\n                        self.raw_args,\n                        self.shorthands,\n                        CONSTANTS,\n                    )\n\n        self.handle_kiosk()\n        if success:\n            raise SystemExit(0)\n        else:\n            raise SystemExit(1)\n\n    def buy_multiple_items(self, items) -> None:\n        for item in items:\n            itm, qnty = parse_split_multibuy(item)\n            if itm in self.shorthands:\n                itm = self.shorthands[itm]\n            itm = int(itm)\n            if itm in self.products:\n                success, output = self.make_purchase({str(itm): int(qnty)})\n                print(output)\n                if not success:\n                    raise SystemExit(1)\n\n    def handle_kiosk(self) -> None:\n        if self.kiosk_mode:\n            sleep(5)\n            raise SystemExit()\n\n    def enter_shop_loop(self) -> None:\n        while True:\n            try:\n                items = input('Id> ').strip()\n            except (EOFError, KeyboardInterrupt):\n                raise SystemExit()\n\n            if items in CONSTANTS['exit_words']:\n                raise SystemExit(0)\n\n            if ' ' in items:\n                items = re.split(r'\\s+', items)\n                self.buy_multiple_items(items)\n            else:\n                itm, qnty = parse_split_multibuy(items)\n                if not itm.isdigit() and itm in self.shorthands:\n                    itm = self.shorthands[itm]\n\n                if type(itm) is str and not itm.isdigit():\n                    print(f'Varen \\'{itm}\\' findes ikke.')\n                    continue\n                itm = int(itm)\n                if itm in self.products:\n                    success, output = self.make_purchase({str(itm): int(qnty)})\n                    print(output)\n                    if not success:\n                        raise SystemExit(1)\n                    if not self.disable_plugins:\n                        for plugin in self.plugins:\n                            if plugin.post_run:\n                                plugin.post_run(\n                                    list(self.products.values()),\n                                    self._argument_handler.args,\n                                    self.raw_args,\n                                    self.shorthands,\n                                    CONSTANTS,\n                                )\n\n                    self.handle_kiosk()\n\n    def shop(self) -> None:\n        if not self.disable_plugins:\n            for plugin in self.plugins:\n                if plugin.pre_argparse:\n                    plugin.run(\n                        list(self.products.values()),\n                        self._argument_handler.args,\n                        self.raw_args,\n                        self.shorthands,\n                        CONSTANTS,\n                    )\n\n                    if self._argument_handler.args.product:\n                        self._argument_handler.args.product = [str(self._argument_handler.args.product)]\n                        self.quickbuy()\n\n        print(self.get_greeting(self._user_manager.get_user()))\n        print(\n            \"Hvad ønsker at købe i Stregsystemet? (Skriv en af [':q', 'exit', 'quit', 'q'] for at komme ud af interfacet)\"\n        )\n        print(self.get_catalogue())\n        print('')\n        self.enter_shop_loop()\n\n    def start_shop(self) -> None:\n\n        if self._argument_handler.has_products():\n            self.quickbuy()\n        else:\n            self.shop()\n\n\nis_windows = sys.platform == \"win32\"\nreferer_header = {'Referer': CONSTANTS['url']}\nbalance = float()\nconfig = configparser.ConfigParser()\n\nuser_id = ''\n\nif is_windows:\n    os.system('color')\n\n\ndef pre_parse(args, parser: argparse.ArgumentParser):\n    parser.add_argument('-z', '--noplugins', action='store_true', help='Disables the plugin loader')\n    parser.add_argument(\n        '-x', '--strandvejen', action='store_true', help='Flag used for the CRT terminal version running in strandvejen'\n    )\n    parser.add_argument('-a', '--update', action='store_true', help='Update the script and then exists')\n    parser.add_argument('-v', '--verbose', action='store_true', help='Prints information about the running script')\n    parser.add_argument('-s', '--setup', action='store_true', help='Runs the setup script')\n    args, _ = parser.parse_known_args(args)\n    return args\n\n\ndef parse(args, parser: argparse.ArgumentParser):\n\n    parser.add_argument(\n        '-u', '--user', default=None, nargs='?', dest='user', help='Specifies your Stregsystem username'\n    )\n    parser.add_argument('-i', '--item', default=None, nargs='?', dest='item', help='Specifies the item you wish to buy')\n    parser.add_argument(\n        '-c',\n        '--count',\n        default=1,\n        nargs='?',\n        dest='count',\n        type=int,\n        help='Specifies the amount of items you wish to buy',\n    )\n    parser.add_argument('-b', '--balance', action='store_true', help='Output only stregdollar balance')\n    parser.add_argument('-l', '--history', action='store_true', help='Shows your recent purchases')\n    parser.add_argument('-p', '--mobilepay', dest='money', help='Provides a QR code to insert money into your account')\n    parser.add_argument('-a', '--update', action='store_true', help='Update the script and then exists')\n    parser.add_argument('-o', '--shorthands', action='store_true', help='Shows shorthands')\n    parser.add_argument('-z', '--noplugins', action='store_true', help='Disables the plugin loader')\n    parser.add_argument(\n        '-x', '--strandvejen', action='store_true', help='Flag used for the CRT terminal version running in strandvejen'\n    )\n    parser.add_argument(\n        '-s', '--setup', action='store_true', help='Creates a .sts at /home/<user> storing your account username'\n    )\n    parser.add_argument('product', type=str, nargs='*', help=\"Specifies the product to buy\")\n    parser.add_argument('-v', '--verbose', action='store_true', help='Prints information about the running script')\n    parser.add_argument('-r', '--rank', action='store_true', help='Shows your rank in different categories')\n    parser.add_argument(\n        '-pi',\n        '--pluginstall',\n        default=None,\n        nargs='?',\n        dest='pluginstall',\n        help='Install a plugin from the community plugins. https://github.com/f-klubben/stregsystemet-cli/tree/master/community_plugins',\n    )\n    parser.add_argument(\n        '-pu',\n        '--pluguninstall',\n        default=None,\n        nargs='?',\n        dest='pluguninstall',\n        help='Remove a plugin from your installation of STS.',\n    )\n\n    args = parser.parse_args(args)\n    return args\n\n\nif __name__ == '__main__' and not force_disable_main:\n    configuration = Configuration()\n\n    arg_array = sys.argv[1::]\n    _parser = argparse.ArgumentParser(add_help=False)\n    _args = pre_parse(arg_array, _parser)\n    if has_version_difference():\n        __builtins__.print(\n            \"Der er en opdatering til STS. Hent den fra GitHub eller kør sts med --update.\", file=sys.stderr\n        )\n\n    sts = Stregsystem(configuration, _args, arg_array)\n    sts.load()\n    sts.start_shop()\n\n# END_STS\n";


var $9b97d97e5ffa991e$exports = {};
$9b97d97e5ffa991e$exports = "import argparse\r\n\r\nfrom cli_helper import user_from_id\r\nfrom worker_xhr import xhr_call\r\nfrom pyodide.ffi import to_js\r\n\r\n# Restore print function that has been replace by sts\r\nprint = _print\r\n\r\n# override http functions in requests module\r\n\r\ndef get(self, url, params):\r\n    return xhr_call(\"GET\", url, to_js(params))\r\n\r\ndef post(self, url, data):\r\n    return xhr_call(\"POST\", url, to_js(data))\r\n\r\nrequests.Session.get = get\r\nrequests.Session.post = post\r\n\r\n# removes product fields that may not be JS transferable\r\n\r\ndef clean_product(p):\r\n    del p['special']\r\n    return p\r\n\r\n# Resume normal startup\r\n\r\ndef startup(url, room):\r\n    global sts, req_handler, user_mgr\r\n\r\n    CONSTANTS['url'] = url\r\n    CONSTANTS['room'] = room\r\n\r\n    config = Configuration()\r\n    args = [ '-z' ] # Flag for disabling plugin loader\r\n    _parser = argparse.ArgumentParser(add_help=False)\r\n    _args = pre_parse(args, _parser)\r\n\r\n    sts = Stregsystem(config, _args, args)\r\n\r\n    req_handler = sts._request_handler\r\n    user_mgr = sts._user_manager";



const $61eff7957713c367$var$html_decoder = document.createElement('span');
/**
 * Decodes an HTML escaped string by inserting it into an HTML element
 * and reading back its inner text.
 * @param src
 */ const $61eff7957713c367$var$decode_html_escapes = (src)=>{
    $61eff7957713c367$var$html_decoder.innerHTML = src;
    return $61eff7957713c367$var$html_decoder.innerText;
};
const $61eff7957713c367$export$34b71a1ba293e1b3 = (username)=>{
    username = JSON.stringify(username);
    return $b22d2393df1c17c8$export$889ea624f2cb2c57(`
    if user_mgr.user.username != ${username}:
        user_mgr.set_user(${username}, req_handler)
    else:
        user_mgr.update_user(req_handler)
    user_mgr.get_user_id()
    `);
};
const $61eff7957713c367$var$reg_username = /<td>Brugernavn<\/td>\s*<td>(.+)<\/td>/;
const $61eff7957713c367$var$reg_firstname = /<td>Fornavn\(e\)<\/td>\s*<td>(.+)<\/td>/;
const $61eff7957713c367$var$reg_lastname = /<td>Efternavn<\/td>\s*<td>(.+)<\/td>/;
const $61eff7957713c367$var$reg_balance = /Du har ([0-9.]+) kroner til gode!/;
const $61eff7957713c367$export$927d0f2977e8112b = (user_id)=>fetch(`${(0, $03718d3379a37d9e$export$2e2bcd8739ae039).base_api_url}/../${(0, $03718d3379a37d9e$export$2e2bcd8739ae039).default_room}/user/${user_id}`).if((res)=>res.status === 200, async (res)=>{
        const response_text = await res.text();
        return {
            username: $61eff7957713c367$var$decode_html_escapes($61eff7957713c367$var$reg_username.exec(response_text)[1]),
            name: [
                $61eff7957713c367$var$decode_html_escapes($61eff7957713c367$var$reg_firstname.exec(response_text)[1]),
                $61eff7957713c367$var$decode_html_escapes($61eff7957713c367$var$reg_lastname.exec(response_text)[1])
            ].join(' '),
            balance: parseFloat($61eff7957713c367$var$reg_balance.exec(response_text)[1]) * 100,
            active: true
        };
    }).else_then_promise(()=>Promise.reject("Unable to get user info."));
const $61eff7957713c367$export$ba899e88c3f6abfc = (user_id)=>$b22d2393df1c17c8$export$889ea624f2cb2c57(`
    if user_mgr.user.user_id != ${user_id}:
        user_mgr.user = await user_from_id(${user_id})
    else:
        user_mgr.update_balance(req_handler)
    user_mgr.get_balance() * 100
    `);
const $61eff7957713c367$export$dc7ee5442df48de0 = async (room_id)=>{
    const py_products = await $b22d2393df1c17c8$export$889ea624f2cb2c57(`
    sts.update_products()
    [clean_product(p.__dict__) for (_, p) in sts.products.items()]
    `);
    const products = {};
    for (const { id: id, name: name, price: price } of py_products)products[id] = [
        name,
        price * 100
    ];
    return products;
};
const $61eff7957713c367$export$4973ffe22c18566 = async (buystring, _, user_id)=>{
    const products = Object.fromEntries(buystring.split(' ').slice(1).map((x)=>x.split(':')).map(([a, b])=>[
            a,
            parseInt(b) || 1
        ]));
    const [status, msg] = await $b22d2393df1c17c8$export$889ea624f2cb2c57(`
    if user_mgr.user.user_id != ${user_id}:
        user_mgr.user = await user_from_id(${user_id})
    to_js(sts.make_purchase(${JSON.stringify(products)}))
    `);
    return {
        status: status,
        msg: msg
    };
};
class $61eff7957713c367$var$CliHelper {
    static async user_from_id(id) {
        const { username: username, balance: balance } = await $61eff7957713c367$export$927d0f2977e8112b(id);
        return {
            username: username,
            balance: balance,
            user_id: id
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    $b22d2393df1c17c8$export$dd9926908f10141b()
], $61eff7957713c367$var$CliHelper, "user_from_id", null);
$61eff7957713c367$var$CliHelper = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    $b22d2393df1c17c8$export$f7d8b214031df6ad("cli_helper")
], $61eff7957713c367$var$CliHelper);
const $61eff7957713c367$export$2cd8252107eb640b = async ()=>{
    await $b22d2393df1c17c8$export$2cd8252107eb640b();
    await $b22d2393df1c17c8$export$4b3e715f166fdd78('requests');
    await $b22d2393df1c17c8$export$37932c8884fc6abc($61eff7957713c367$var$CliHelper);
    await $b22d2393df1c17c8$export$889ea624f2cb2c57(`
    force_disable_main = True
    _print = print # sts replaces print so we need keep a reference for later
    `);
    await $b22d2393df1c17c8$export$889ea624f2cb2c57((0, (/*@__PURE__*/$parcel$interopDefault($30bcbd229619e834$exports))));
    await $b22d2393df1c17c8$export$889ea624f2cb2c57((0, (/*@__PURE__*/$parcel$interopDefault($9b97d97e5ffa991e$exports))));
    await $b22d2393df1c17c8$export$889ea624f2cb2c57(`
    startup(
        '${(0, $03718d3379a37d9e$export$2e2bcd8739ae039).base_api_url.substring(0, (0, $03718d3379a37d9e$export$2e2bcd8739ae039).base_api_url.length - 4)}',
        '${(0, $03718d3379a37d9e$export$2e2bcd8739ae039).default_room}',
        )
    `);
};


var $64c315428a4a72bb$exports = {};

$parcel$export($64c315428a4a72bb$exports, "get_member_id", () => $64c315428a4a72bb$export$34b71a1ba293e1b3);
$parcel$export($64c315428a4a72bb$exports, "get_member_info", () => $64c315428a4a72bb$export$927d0f2977e8112b);
$parcel$export($64c315428a4a72bb$exports, "get_member_balance", () => $64c315428a4a72bb$export$ba899e88c3f6abfc);
$parcel$export($64c315428a4a72bb$exports, "get_active_products", () => $64c315428a4a72bb$export$dc7ee5442df48de0);
$parcel$export($64c315428a4a72bb$exports, "post_sale", () => $64c315428a4a72bb$export$4973ffe22c18566);
$parcel$export($64c315428a4a72bb$exports, "init", () => $64c315428a4a72bb$export$2cd8252107eb640b);


const { base_api_url: $64c315428a4a72bb$var$base_api_url } = (0, $03718d3379a37d9e$export$2e2bcd8739ae039);
const $64c315428a4a72bb$export$34b71a1ba293e1b3 = (username)=>fetch(`${$64c315428a4a72bb$var$base_api_url}/member/get_id?username=${username}`).then((res)=>(0, $d65da55d02f5d4e6$export$a6d0699925e990d2)(res.status === 200, res, "Invalid status code")).then((res)=>res.json()).then((value)=>value['member_id']);
const $64c315428a4a72bb$export$927d0f2977e8112b = (user_id)=>fetch(`${$64c315428a4a72bb$var$base_api_url}/member?member_id=${user_id}`).then((res)=>(0, $d65da55d02f5d4e6$export$a6d0699925e990d2)(res.status === 200, res, res)).then((res)=>res.json());
const $64c315428a4a72bb$export$ba899e88c3f6abfc = (user_id)=>fetch(`${$64c315428a4a72bb$var$base_api_url}/member/balance?member_id=${user_id}`).then((res)=>(0, $d65da55d02f5d4e6$export$a6d0699925e990d2)(res.status === 200, res, res)).then((res)=>res.json()).then((value)=>value['balance']);
const $64c315428a4a72bb$export$dc7ee5442df48de0 = (room_id)=>fetch(`${$64c315428a4a72bb$var$base_api_url}/products/active_products?room_id=${room_id}`).then((res)=>(0, $d65da55d02f5d4e6$export$a6d0699925e990d2)(res.status === 200, res, res)).then((res)=>res.json());
const $64c315428a4a72bb$export$4973ffe22c18566 = (buystring, room, user_id)=>fetch(`${$64c315428a4a72bb$var$base_api_url}/sale`, {
        method: 'POST',
        cache: "no-cache",
        headers: {
            "Content-Type": 'application/json'
        },
        body: JSON.stringify({
            buystring: buystring,
            room: room,
            member_id: `${user_id}`
        })
    }).then((res)=>(0, $d65da55d02f5d4e6$export$a6d0699925e990d2)(res.status === 200, res, res)).then((res)=>res.json());
const $64c315428a4a72bb$export$2cd8252107eb640b = ()=>Promise.resolve();


var $7fda80fa9598ab09$exports = {};
$7fda80fa9598ab09$exports = "<p class=center>Unable to connect to stregsystem! 😦 <br>\nMake sure that you are connected to AAU network/VPN.";


var $18ca72d7af810590$exports = {};
$18ca72d7af810590$exports = "<p class=center>Unable to access the stregsystem API! 😦 <br>\nNothing to be done. Check back once stregsystemet has been updated...";



var $3gJDb = parcelRequire("3gJDb");
/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.7, Wed Mar 20 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $2f895839ac78ac6c$var$__assign = function() {
    $2f895839ac78ac6c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f895839ac78ac6c$var$__assign.apply(this, arguments);
};
function $2f895839ac78ac6c$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $2f895839ac78ac6c$var$_global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var $2f895839ac78ac6c$var$keys = Object.keys;
var $2f895839ac78ac6c$var$isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !$2f895839ac78ac6c$var$_global.Promise) $2f895839ac78ac6c$var$_global.Promise = Promise;
function $2f895839ac78ac6c$var$extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    $2f895839ac78ac6c$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $2f895839ac78ac6c$var$getProto = Object.getPrototypeOf;
var $2f895839ac78ac6c$var$_hasOwn = {}.hasOwnProperty;
function $2f895839ac78ac6c$var$hasOwn(obj, prop) {
    return $2f895839ac78ac6c$var$_hasOwn.call(obj, prop);
}
function $2f895839ac78ac6c$var$props(proto, extension) {
    if (typeof extension === 'function') extension = extension($2f895839ac78ac6c$var$getProto(proto));
    (typeof Reflect === "undefined" ? $2f895839ac78ac6c$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $2f895839ac78ac6c$var$setProp(proto, key, extension[key]);
    });
}
var $2f895839ac78ac6c$var$defineProperty = Object.defineProperty;
function $2f895839ac78ac6c$var$setProp(obj, prop, functionOrGetSet, options) {
    $2f895839ac78ac6c$var$defineProperty(obj, prop, $2f895839ac78ac6c$var$extend(functionOrGetSet && $2f895839ac78ac6c$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $2f895839ac78ac6c$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $2f895839ac78ac6c$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $2f895839ac78ac6c$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $2f895839ac78ac6c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $2f895839ac78ac6c$var$getPropertyDescriptor(obj, prop) {
    var pd = $2f895839ac78ac6c$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $2f895839ac78ac6c$var$getProto(obj)) && $2f895839ac78ac6c$var$getPropertyDescriptor(proto, prop);
}
var $2f895839ac78ac6c$var$_slice = [].slice;
function $2f895839ac78ac6c$var$slice(args, start, end) {
    return $2f895839ac78ac6c$var$_slice.call(args, start, end);
}
function $2f895839ac78ac6c$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $2f895839ac78ac6c$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $2f895839ac78ac6c$var$asap$1(fn) {
    if ($2f895839ac78ac6c$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $2f895839ac78ac6c$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $2f895839ac78ac6c$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && $2f895839ac78ac6c$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $2f895839ac78ac6c$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $2f895839ac78ac6c$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$2f895839ac78ac6c$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$2f895839ac78ac6c$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $2f895839ac78ac6c$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $2f895839ac78ac6c$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        $2f895839ac78ac6c$var$setByKeyPath(obj, kp, undefined);
    });
}
function $2f895839ac78ac6c$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $2f895839ac78ac6c$var$concat = [].concat;
function $2f895839ac78ac6c$var$flatten(a) {
    return $2f895839ac78ac6c$var$concat.apply([], a);
}
var $2f895839ac78ac6c$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat($2f895839ac78ac6c$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
var $2f895839ac78ac6c$var$intrinsicTypes = $2f895839ac78ac6c$var$intrinsicTypeNames.map(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
$2f895839ac78ac6c$var$arrayToObject($2f895839ac78ac6c$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $2f895839ac78ac6c$var$circularRefs = null;
function $2f895839ac78ac6c$var$deepClone(any) {
    $2f895839ac78ac6c$var$circularRefs = typeof WeakMap !== 'undefined' && new WeakMap();
    var rv = $2f895839ac78ac6c$var$innerDeepClone(any);
    $2f895839ac78ac6c$var$circularRefs = null;
    return rv;
}
function $2f895839ac78ac6c$var$innerDeepClone(any) {
    if (!any || typeof any !== 'object') return any;
    var rv = $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.get(any);
    if (rv) return rv;
    if ($2f895839ac78ac6c$var$isArray(any)) {
        rv = [];
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($2f895839ac78ac6c$var$innerDeepClone(any[i]));
    } else if ($2f895839ac78ac6c$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $2f895839ac78ac6c$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var prop in any)if ($2f895839ac78ac6c$var$hasOwn(any, prop)) rv[prop] = $2f895839ac78ac6c$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $2f895839ac78ac6c$var$toString = {}.toString;
function $2f895839ac78ac6c$var$toStringTag(o) {
    return $2f895839ac78ac6c$var$toString.call(o).slice(8, -1);
}
var $2f895839ac78ac6c$var$iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var $2f895839ac78ac6c$var$getIteratorOf = typeof $2f895839ac78ac6c$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$2f895839ac78ac6c$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $2f895839ac78ac6c$var$NO_CHAR_ARRAY = {};
function $2f895839ac78ac6c$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($2f895839ac78ac6c$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $2f895839ac78ac6c$var$NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = $2f895839ac78ac6c$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $2f895839ac78ac6c$var$isAsyncFunction = typeof Symbol !== 'undefined' ? function(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var $2f895839ac78ac6c$var$debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $2f895839ac78ac6c$var$setDebug(value, filter) {
    $2f895839ac78ac6c$var$debug = value;
    $2f895839ac78ac6c$var$libraryFilter = filter;
}
var $2f895839ac78ac6c$var$libraryFilter = function() {
    return true;
};
var $2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $2f895839ac78ac6c$var$getErrorWithStack() {
    if ($2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK) try {
        $2f895839ac78ac6c$var$getErrorWithStack.arguments;
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $2f895839ac78ac6c$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split('\n').length;
    return stack.split('\n').slice(numIgnoredFrames).filter($2f895839ac78ac6c$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join('');
}
var $2f895839ac78ac6c$var$dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var $2f895839ac78ac6c$var$idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var $2f895839ac78ac6c$var$errorList = $2f895839ac78ac6c$var$dexieErrorNames.concat($2f895839ac78ac6c$var$idbDomErrorNames);
var $2f895839ac78ac6c$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $2f895839ac78ac6c$var$DexieError(name, msg) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$DexieError).from(Error).extend({
    stack: {
        get: function() {
            return this._stack || (this._stack = this.name + ": " + this.message + $2f895839ac78ac6c$var$prettyStack(this._e, 2));
        }
    },
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function $2f895839ac78ac6c$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$ModifyError).from($2f895839ac78ac6c$var$DexieError);
function $2f895839ac78ac6c$var$BulkError(msg, failures) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$BulkError).from($2f895839ac78ac6c$var$DexieError);
var $2f895839ac78ac6c$var$errnames = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $2f895839ac78ac6c$var$BaseException = $2f895839ac78ac6c$var$DexieError;
var $2f895839ac78ac6c$var$exceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $2f895839ac78ac6c$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $2f895839ac78ac6c$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "" + msgOrInner + (!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $2f895839ac78ac6c$var$derive(DexieError).from($2f895839ac78ac6c$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$2f895839ac78ac6c$var$exceptions.Syntax = SyntaxError;
$2f895839ac78ac6c$var$exceptions.Type = TypeError;
$2f895839ac78ac6c$var$exceptions.Range = RangeError;
var $2f895839ac78ac6c$var$exceptionMap = $2f895839ac78ac6c$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
function $2f895839ac78ac6c$var$mapError(domError, message) {
    if (!domError || domError instanceof $2f895839ac78ac6c$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$2f895839ac78ac6c$var$exceptionMap[domError.name]) return domError;
    var rv = new $2f895839ac78ac6c$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $2f895839ac78ac6c$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $2f895839ac78ac6c$var$fullNameExceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
$2f895839ac78ac6c$var$fullNameExceptions.ModifyError = $2f895839ac78ac6c$var$ModifyError;
$2f895839ac78ac6c$var$fullNameExceptions.DexieError = $2f895839ac78ac6c$var$DexieError;
$2f895839ac78ac6c$var$fullNameExceptions.BulkError = $2f895839ac78ac6c$var$BulkError;
function $2f895839ac78ac6c$var$nop() {}
function $2f895839ac78ac6c$var$mirror(val) {
    return val;
}
function $2f895839ac78ac6c$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $2f895839ac78ac6c$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $2f895839ac78ac6c$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$hookCreatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $2f895839ac78ac6c$var$hookDeletingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $2f895839ac78ac6c$var$hookUpdatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $2f895839ac78ac6c$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $2f895839ac78ac6c$var$extend(res, res2);
    };
}
function $2f895839ac78ac6c$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$promisableChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $2f895839ac78ac6c$var$INTERNAL = {};
var $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT = 100, $2f895839ac78ac6c$var$MAX_LONG_STACKS = 20, $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT = 100, $2f895839ac78ac6c$var$_a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        $2f895839ac78ac6c$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $2f895839ac78ac6c$var$getProto(nativeP),
        globalP
    ];
}(), $2f895839ac78ac6c$var$resolvedNativePromise = $2f895839ac78ac6c$var$_a$1[0], $2f895839ac78ac6c$var$nativePromiseProto = $2f895839ac78ac6c$var$_a$1[1], $2f895839ac78ac6c$var$resolvedGlobalPromise = $2f895839ac78ac6c$var$_a$1[2], $2f895839ac78ac6c$var$nativePromiseThen = $2f895839ac78ac6c$var$nativePromiseProto && $2f895839ac78ac6c$var$nativePromiseProto.then;
var $2f895839ac78ac6c$var$NativePromise = $2f895839ac78ac6c$var$resolvedNativePromise && $2f895839ac78ac6c$var$resolvedNativePromise.constructor;
var $2f895839ac78ac6c$var$patchGlobalPromise = !!$2f895839ac78ac6c$var$resolvedGlobalPromise;
var $2f895839ac78ac6c$var$stack_being_generated = false;
var $2f895839ac78ac6c$var$schedulePhysicalTick = $2f895839ac78ac6c$var$resolvedGlobalPromise ? function() {
    $2f895839ac78ac6c$var$resolvedGlobalPromise.then($2f895839ac78ac6c$var$physicalTick);
} : $2f895839ac78ac6c$var$_global.setImmediate ? setImmediate.bind(null, $2f895839ac78ac6c$var$physicalTick) : $2f895839ac78ac6c$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $2f895839ac78ac6c$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute('i', '1');
} : function() {
    setTimeout($2f895839ac78ac6c$var$physicalTick, 0);
};
var $2f895839ac78ac6c$var$asap = function(callback, args) {
    $2f895839ac78ac6c$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($2f895839ac78ac6c$var$needsNewPhysicalTick) {
        $2f895839ac78ac6c$var$schedulePhysicalTick();
        $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    }
};
var $2f895839ac78ac6c$var$isOutsideMicroTick = true, $2f895839ac78ac6c$var$needsNewPhysicalTick = true, $2f895839ac78ac6c$var$unhandledErrors = [], $2f895839ac78ac6c$var$rejectingErrors = [], $2f895839ac78ac6c$var$currentFulfiller = null, $2f895839ac78ac6c$var$rejectionMapper = $2f895839ac78ac6c$var$mirror;
var $2f895839ac78ac6c$var$globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $2f895839ac78ac6c$var$globalError,
    pgp: false,
    env: {},
    finalize: function() {
        this.unhandleds.forEach(function(uh) {
            try {
                $2f895839ac78ac6c$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $2f895839ac78ac6c$var$PSD = $2f895839ac78ac6c$var$globalPSD;
var $2f895839ac78ac6c$var$microtickQueue = [];
var $2f895839ac78ac6c$var$numScheduledCalls = 0;
var $2f895839ac78ac6c$var$tickFinalizers = [];
function $2f895839ac78ac6c$var$DexiePromise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this.onuncatched = $2f895839ac78ac6c$var$nop;
    this._lib = false;
    var psd = this._PSD = $2f895839ac78ac6c$var$PSD;
    if ($2f895839ac78ac6c$var$debug) {
        this._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== 'function') {
        if (fn !== $2f895839ac78ac6c$var$INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $2f895839ac78ac6c$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $2f895839ac78ac6c$var$executePromiseTask(this, fn);
}
var $2f895839ac78ac6c$var$thenProp = {
    get: function() {
        var psd = $2f895839ac78ac6c$var$PSD, microTaskId = $2f895839ac78ac6c$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $2f895839ac78ac6c$var$PSD || microTaskId !== $2f895839ac78ac6c$var$totalEchoes);
            var cleanup = possibleAwait && !$2f895839ac78ac6c$var$decrementExpectedAwaits();
            var rv = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                $2f895839ac78ac6c$var$propagateToListener(_this, new $2f895839ac78ac6c$var$Listener($2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $2f895839ac78ac6c$var$debug && $2f895839ac78ac6c$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $2f895839ac78ac6c$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $2f895839ac78ac6c$var$setProp(this, 'then', value && value.prototype === $2f895839ac78ac6c$var$INTERNAL ? $2f895839ac78ac6c$var$thenProp : {
            get: function() {
                return value;
            },
            set: $2f895839ac78ac6c$var$thenProp.set
        });
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise.prototype, {
    then: $2f895839ac78ac6c$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $2f895839ac78ac6c$var$propagateToListener(this, new $2f895839ac78ac6c$var$Listener(null, null, onFulfilled, onRejected, $2f895839ac78ac6c$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    stack: {
        get: function() {
            if (this._stack) return this._stack;
            try {
                $2f895839ac78ac6c$var$stack_being_generated = true;
                var stacks = $2f895839ac78ac6c$var$getStack(this, [], $2f895839ac78ac6c$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $2f895839ac78ac6c$var$stack_being_generated = false;
            }
        }
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $2f895839ac78ac6c$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
$2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
function $2f895839ac78ac6c$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise, {
    all: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $2f895839ac78ac6c$var$DexiePromise) return value;
        if (value && typeof value.then === 'function') return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, true, value);
        $2f895839ac78ac6c$var$linkToPreviousPromise(rv, $2f895839ac78ac6c$var$currentFulfiller);
        return rv;
    },
    reject: $2f895839ac78ac6c$var$PromiseReject,
    race: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD;
        },
        set: function(value) {
            return $2f895839ac78ac6c$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $2f895839ac78ac6c$var$totalEchoes;
        }
    },
    newPSD: $2f895839ac78ac6c$var$newScope,
    usePSD: $2f895839ac78ac6c$var$usePSD,
    scheduler: {
        get: function() {
            return $2f895839ac78ac6c$var$asap;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $2f895839ac78ac6c$var$rejectionMapper;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function(resolve, reject) {
                var psd = $2f895839ac78ac6c$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $2f895839ac78ac6c$var$callBoth(function() {
                    var _this = this;
                    $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($2f895839ac78ac6c$var$NativePromise) {
    if ($2f895839ac78ac6c$var$NativePromise.allSettled) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($2f895839ac78ac6c$var$NativePromise.any && typeof AggregateError !== 'undefined') $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "any", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $2f895839ac78ac6c$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
            if (value && typeof value.then === 'function') $2f895839ac78ac6c$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $2f895839ac78ac6c$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $2f895839ac78ac6c$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
        }, $2f895839ac78ac6c$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $2f895839ac78ac6c$var$handleRejection(promise, ex);
    }
}
function $2f895839ac78ac6c$var$handleRejection(promise, reason) {
    $2f895839ac78ac6c$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
    reason = $2f895839ac78ac6c$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $2f895839ac78ac6c$var$debug && reason !== null && typeof reason === 'object' && !reason._promise && $2f895839ac78ac6c$var$tryCatch(function() {
        var origProp = $2f895839ac78ac6c$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $2f895839ac78ac6c$var$setProp(reason, "stack", {
            get: function() {
                return $2f895839ac78ac6c$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise);
    $2f895839ac78ac6c$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$2f895839ac78ac6c$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($2f895839ac78ac6c$var$numScheduledCalls === 0) {
        ++$2f895839ac78ac6c$var$numScheduledCalls;
        $2f895839ac78ac6c$var$asap(function() {
            if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        }, []);
    }
}
function $2f895839ac78ac6c$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap($2f895839ac78ac6c$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $2f895839ac78ac6c$var$callListener(cb, promise, listener) {
    try {
        $2f895839ac78ac6c$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($2f895839ac78ac6c$var$rejectingErrors.length) $2f895839ac78ac6c$var$rejectingErrors = [];
            ret = cb(value);
            if ($2f895839ac78ac6c$var$rejectingErrors.indexOf(value) === -1) $2f895839ac78ac6c$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $2f895839ac78ac6c$var$currentFulfiller = null;
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $2f895839ac78ac6c$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $2f895839ac78ac6c$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($2f895839ac78ac6c$var$debug) {
        stack = $2f895839ac78ac6c$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $2f895839ac78ac6c$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $2f895839ac78ac6c$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $2f895839ac78ac6c$var$physicalTick() {
    $2f895839ac78ac6c$var$beginMicroTickScope() && $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$beginMicroTickScope() {
    var wasRootExec = $2f895839ac78ac6c$var$isOutsideMicroTick;
    $2f895839ac78ac6c$var$isOutsideMicroTick = false;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $2f895839ac78ac6c$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($2f895839ac78ac6c$var$microtickQueue.length > 0){
        callbacks = $2f895839ac78ac6c$var$microtickQueue;
        $2f895839ac78ac6c$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($2f895839ac78ac6c$var$microtickQueue.length > 0);
    $2f895839ac78ac6c$var$isOutsideMicroTick = true;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = true;
}
function $2f895839ac78ac6c$var$finalizePhysicalTick() {
    var unhandledErrs = $2f895839ac78ac6c$var$unhandledErrors;
    $2f895839ac78ac6c$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $2f895839ac78ac6c$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $2f895839ac78ac6c$var$tickFinalizers.splice($2f895839ac78ac6c$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $2f895839ac78ac6c$var$tickFinalizers.push(finalizer);
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap(function() {
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
    }, []);
}
function $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise) {
    if (!$2f895839ac78ac6c$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $2f895839ac78ac6c$var$unhandledErrors.push(promise);
}
function $2f895839ac78ac6c$var$markErrorAsHandled(promise) {
    var i = $2f895839ac78ac6c$var$unhandledErrors.length;
    while(i)if ($2f895839ac78ac6c$var$unhandledErrors[--i]._value === promise._value) {
        $2f895839ac78ac6c$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $2f895839ac78ac6c$var$PromiseReject(reason) {
    return new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, false, reason);
}
function $2f895839ac78ac6c$var$wrap(fn, errorCatcher) {
    var psd = $2f895839ac78ac6c$var$PSD;
    return function() {
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope(), outerScope = $2f895839ac78ac6c$var$PSD;
        try {
            $2f895839ac78ac6c$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerScope, false);
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
}
var $2f895839ac78ac6c$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $2f895839ac78ac6c$var$taskCounter = 0;
var $2f895839ac78ac6c$var$zoneStack = [];
var $2f895839ac78ac6c$var$zoneEchoes = 0;
var $2f895839ac78ac6c$var$totalEchoes = 0;
var $2f895839ac78ac6c$var$zone_id_counter = 0;
function $2f895839ac78ac6c$var$newScope(fn, props, a1, a2) {
    var parent = $2f895839ac78ac6c$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$2f895839ac78ac6c$var$zone_id_counter;
    var globalEnv = $2f895839ac78ac6c$var$globalPSD.env;
    psd.env = $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: $2f895839ac78ac6c$var$DexiePromise,
        PromiseProp: {
            value: $2f895839ac78ac6c$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $2f895839ac78ac6c$var$DexiePromise.all,
        race: $2f895839ac78ac6c$var$DexiePromise.race,
        allSettled: $2f895839ac78ac6c$var$DexiePromise.allSettled,
        any: $2f895839ac78ac6c$var$DexiePromise.any,
        resolve: $2f895839ac78ac6c$var$DexiePromise.resolve,
        reject: $2f895839ac78ac6c$var$DexiePromise.reject,
        nthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $2f895839ac78ac6c$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $2f895839ac78ac6c$var$incrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.id) $2f895839ac78ac6c$var$task.id = ++$2f895839ac78ac6c$var$taskCounter;
    ++$2f895839ac78ac6c$var$task.awaits;
    $2f895839ac78ac6c$var$task.echoes += $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return $2f895839ac78ac6c$var$task.id;
}
function $2f895839ac78ac6c$var$decrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.awaits) return false;
    if (--$2f895839ac78ac6c$var$task.awaits === 0) $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.awaits * $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return true;
}
if (('' + $2f895839ac78ac6c$var$nativePromiseThen).indexOf('[native code]') === -1) $2f895839ac78ac6c$var$incrementExpectedAwaits = $2f895839ac78ac6c$var$decrementExpectedAwaits = $2f895839ac78ac6c$var$nop;
function $2f895839ac78ac6c$var$onPossibleParallellAsync(possiblePromise) {
    if ($2f895839ac78ac6c$var$task.echoes && possiblePromise && possiblePromise.constructor === $2f895839ac78ac6c$var$NativePromise) {
        $2f895839ac78ac6c$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $2f895839ac78ac6c$var$zoneEnterEcho(targetZone) {
    ++$2f895839ac78ac6c$var$totalEchoes;
    if (!$2f895839ac78ac6c$var$task.echoes || --$2f895839ac78ac6c$var$task.echoes === 0) $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$zoneStack.push($2f895839ac78ac6c$var$PSD);
    $2f895839ac78ac6c$var$switchToZone(targetZone, true);
}
function $2f895839ac78ac6c$var$zoneLeaveEcho() {
    var zone = $2f895839ac78ac6c$var$zoneStack[$2f895839ac78ac6c$var$zoneStack.length - 1];
    $2f895839ac78ac6c$var$zoneStack.pop();
    $2f895839ac78ac6c$var$switchToZone(zone, false);
}
function $2f895839ac78ac6c$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $2f895839ac78ac6c$var$PSD;
    if (bEnteringZone ? $2f895839ac78ac6c$var$task.echoes && (!$2f895839ac78ac6c$var$zoneEchoes++ || targetZone !== $2f895839ac78ac6c$var$PSD) : $2f895839ac78ac6c$var$zoneEchoes && (!--$2f895839ac78ac6c$var$zoneEchoes || targetZone !== $2f895839ac78ac6c$var$PSD)) $2f895839ac78ac6c$var$enqueueNativeMicroTask(bEnteringZone ? $2f895839ac78ac6c$var$zoneEnterEcho.bind(null, targetZone) : $2f895839ac78ac6c$var$zoneLeaveEcho);
    if (targetZone === $2f895839ac78ac6c$var$PSD) return;
    $2f895839ac78ac6c$var$PSD = targetZone;
    if (currentZone === $2f895839ac78ac6c$var$globalPSD) $2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
    if ($2f895839ac78ac6c$var$patchGlobalPromise) {
        var GlobalPromise_1 = $2f895839ac78ac6c$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $2f895839ac78ac6c$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($2f895839ac78ac6c$var$_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $2f895839ac78ac6c$var$snapShot() {
    var GlobalPromise = $2f895839ac78ac6c$var$_global.Promise;
    return $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($2f895839ac78ac6c$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $2f895839ac78ac6c$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $2f895839ac78ac6c$var$PSD;
    try {
        $2f895839ac78ac6c$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $2f895839ac78ac6c$var$switchToZone(outerScope, false);
    }
}
function $2f895839ac78ac6c$var$enqueueNativeMicroTask(job) {
    $2f895839ac78ac6c$var$nativePromiseThen.call($2f895839ac78ac6c$var$resolvedNativePromise, job);
}
function $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = $2f895839ac78ac6c$var$PSD;
        if (possibleAwait) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        $2f895839ac78ac6c$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerZone, false);
            if (cleanup) $2f895839ac78ac6c$var$enqueueNativeMicroTask($2f895839ac78ac6c$var$decrementExpectedAwaits);
        }
    };
}
function $2f895839ac78ac6c$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onResolved, zone), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $2f895839ac78ac6c$var$UNHANDLEDREJECTION = "unhandledrejection";
function $2f895839ac78ac6c$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($2f895839ac78ac6c$var$_global.document && document.createEvent) {
            event = document.createEvent('Event');
            event.initEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, true, true);
            $2f895839ac78ac6c$var$extend(event, eventData);
        } else if ($2f895839ac78ac6c$var$_global.CustomEvent) {
            event = new CustomEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $2f895839ac78ac6c$var$extend(event, eventData);
        }
        if (event && $2f895839ac78ac6c$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$2f895839ac78ac6c$var$_global.PromiseRejectionEvent && $2f895839ac78ac6c$var$_global.onunhandledrejection) try {
                $2f895839ac78ac6c$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($2f895839ac78ac6c$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $2f895839ac78ac6c$var$rejection = $2f895839ac78ac6c$var$DexiePromise.reject;
function $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$2f895839ac78ac6c$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
            db.open().catch($2f895839ac78ac6c$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function() {
                $2f895839ac78ac6c$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $2f895839ac78ac6c$var$DEXIE_VERSION = '3.2.7';
var $2f895839ac78ac6c$var$maxString = String.fromCharCode(65535);
var $2f895839ac78ac6c$var$minKey = -Infinity;
var $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $2f895839ac78ac6c$var$STRING_EXPECTED = "String expected.";
var $2f895839ac78ac6c$var$connections = [];
var $2f895839ac78ac6c$var$isIEOrEdge = typeof navigator !== 'undefined' && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$dexieStackFrameFilter = function(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $2f895839ac78ac6c$var$DBNAMES_DB = '__dbnames';
var $2f895839ac78ac6c$var$READONLY = 'readonly';
var $2f895839ac78ac6c$var$READWRITE = 'readwrite';
function $2f895839ac78ac6c$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $2f895839ac78ac6c$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $2f895839ac78ac6c$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $2f895839ac78ac6c$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $2f895839ac78ac6c$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $2f895839ac78ac6c$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $2f895839ac78ac6c$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD
            }) : $2f895839ac78ac6c$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if ($2f895839ac78ac6c$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join('+') + "]");
        var keyPaths = $2f895839ac78ac6c$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $2f895839ac78ac6c$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $2f895839ac78ac6c$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join('+') + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $2f895839ac78ac6c$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $2f895839ac78ac6c$var$getByKeyPath(x, keyPath);
                    return $2f895839ac78ac6c$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $2f895839ac78ac6c$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $2f895839ac78ac6c$var$isArray(index) ? "[" + index.join('+') + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === 'object' && !$2f895839ac78ac6c$var$isArray(keyOrObject)) {
            var key = $2f895839ac78ac6c$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $2f895839ac78ac6c$var$keys(modifications).forEach(function(keyPath) {
                    $2f895839ac78ac6c$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: $2f895839ac78ac6c$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $2f895839ac78ac6c$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $2f895839ac78ac6c$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $2f895839ac78ac6c$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $2f895839ac78ac6c$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($2f895839ac78ac6c$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, $2f895839ac78ac6c$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $2f895839ac78ac6c$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $2f895839ac78ac6c$var$makeClassConstructor(prototype, constructor) {
    $2f895839ac78ac6c$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $2f895839ac78ac6c$var$createTableConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $2f895839ac78ac6c$var$Events(null, {
            "creating": [
                $2f895839ac78ac6c$var$hookCreatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "reading": [
                $2f895839ac78ac6c$var$pureFunctionChain,
                $2f895839ac78ac6c$var$mirror
            ],
            "updating": [
                $2f895839ac78ac6c$var$hookUpdatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "deleting": [
                $2f895839ac78ac6c$var$hookDeletingChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
    });
}
function $2f895839ac78ac6c$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $2f895839ac78ac6c$var$addFilter(ctx, fn) {
    ctx.filter = $2f895839ac78ac6c$var$combine(ctx.filter, fn);
}
function $2f895839ac78ac6c$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $2f895839ac78ac6c$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $2f895839ac78ac6c$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $2f895839ac78ac6c$var$combine(ctx.isMatch, fn);
}
function $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $2f895839ac78ac6c$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $2f895839ac78ac6c$var$openCursor(ctx, coreTable, trans) {
    var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $2f895839ac78ac6c$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $2f895839ac78ac6c$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), $2f895839ac78ac6c$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!$2f895839ac78ac6c$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $2f895839ac78ac6c$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $2f895839ac78ac6c$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $2f895839ac78ac6c$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $2f895839ac78ac6c$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $2f895839ac78ac6c$var$cmp(a, b) {
    try {
        var ta = $2f895839ac78ac6c$var$type(a);
        var tb = $2f895839ac78ac6c$var$type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return $2f895839ac78ac6c$var$compareUint8Arrays($2f895839ac78ac6c$var$getUint8Array(a), $2f895839ac78ac6c$var$getUint8Array(b));
            case 'Array':
                return $2f895839ac78ac6c$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $2f895839ac78ac6c$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $2f895839ac78ac6c$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$type(x) {
    var t = typeof x;
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = $2f895839ac78ac6c$var$toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function $2f895839ac78ac6c$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $2f895839ac78ac6c$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $2f895839ac78ac6c$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $2f895839ac78ac6c$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $2f895839ac78ac6c$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $2f895839ac78ac6c$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $2f895839ac78ac6c$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $2f895839ac78ac6c$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx)) $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $2f895839ac78ac6c$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $2f895839ac78ac6c$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $2f895839ac78ac6c$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else {
                var keyPaths = $2f895839ac78ac6c$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($2f895839ac78ac6c$var$getByKeyPath(item, keyPath) !== val) {
                            $2f895839ac78ac6c$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $2f895839ac78ac6c$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $2f895839ac78ac6c$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $2f895839ac78ac6c$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $2f895839ac78ac6c$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || changes === $2f895839ac78ac6c$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $2f895839ac78ac6c$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $2f895839ac78ac6c$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $2f895839ac78ac6c$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($2f895839ac78ac6c$var$deleteCallback);
    };
    return Collection;
}();
var $2f895839ac78ac6c$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $2f895839ac78ac6c$var$createCollectionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $2f895839ac78ac6c$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $2f895839ac78ac6c$var$mirror ? readingHook : null
        };
    });
}
function $2f895839ac78ac6c$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $2f895839ac78ac6c$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $2f895839ac78ac6c$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$rangeEqual("");
    }).limit(0);
}
function $2f895839ac78ac6c$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $2f895839ac78ac6c$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return $2f895839ac78ac6c$var$fail(whereClause, $2f895839ac78ac6c$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $2f895839ac78ac6c$var$upperFactory(dir);
        lower = $2f895839ac78ac6c$var$lowerFactory(dir);
        compare = dir === "next" ? $2f895839ac78ac6c$var$simpleCompare : $2f895839ac78ac6c$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $2f895839ac78ac6c$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $2f895839ac78ac6c$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $2f895839ac78ac6c$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $2f895839ac78ac6c$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $2f895839ac78ac6c$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$STRING_EXPECTED);
        return this.between(str, str + $2f895839ac78ac6c$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $2f895839ac78ac6c$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $2f895839ac78ac6c$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $2f895839ac78ac6c$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $2f895839ac78ac6c$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return $2f895839ac78ac6c$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $2f895839ac78ac6c$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $2f895839ac78ac6c$var$createWhereClauseConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $2f895839ac78ac6c$var$eventRejectHandler(reject) {
    return $2f895839ac78ac6c$var$wrap(function(event) {
        $2f895839ac78ac6c$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $2f895839ac78ac6c$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var $2f895839ac78ac6c$var$globalEvents = $2f895839ac78ac6c$var$Events(null, $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $2f895839ac78ac6c$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $2f895839ac78ac6c$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $2f895839ac78ac6c$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $2f895839ac78ac6c$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $2f895839ac78ac6c$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $2f895839ac78ac6c$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $2f895839ac78ac6c$var$exceptions.TransactionInactive();
        $2f895839ac78ac6c$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this.active && _this._reject(new $2f895839ac78ac6c$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $2f895839ac78ac6c$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.TransactionInactive());
        if (this._locked()) return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $2f895839ac78ac6c$var$PSD
            ]);
        });
        else if (bWriteLock) return $2f895839ac78ac6c$var$newScope(function() {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $2f895839ac78ac6c$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($2f895839ac78ac6c$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $2f895839ac78ac6c$var$createTransactionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $2f895839ac78ac6c$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + $2f895839ac78ac6c$var$nameFromKeyPath(keyPath)
    };
}
function $2f895839ac78ac6c$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function $2f895839ac78ac6c$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $2f895839ac78ac6c$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $2f895839ac78ac6c$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $2f895839ac78ac6c$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return $2f895839ac78ac6c$var$maxString;
        };
        return $2f895839ac78ac6c$var$maxString;
    }
};
function $2f895839ac78ac6c$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $2f895839ac78ac6c$var$_id_counter = 0;
function $2f895839ac78ac6c$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[" + keyPath.join('+') + "]";
}
function $2f895839ac78ac6c$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $2f895839ac78ac6c$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                        },
                        indexes: $2f895839ac78ac6c$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $2f895839ac78ac6c$var$preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$2f895839ac78ac6c$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $2f895839ac78ac6c$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $2f895839ac78ac6c$var$wrap(resolveIteration);
                            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $2f895839ac78ac6c$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $2f895839ac78ac6c$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $2f895839ac78ac6c$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $2f895839ac78ac6c$var$createMiddlewareStack($2f895839ac78ac6c$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $2f895839ac78ac6c$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $2f895839ac78ac6c$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $2f895839ac78ac6c$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $2f895839ac78ac6c$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $2f895839ac78ac6c$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $2f895839ac78ac6c$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $2f895839ac78ac6c$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $2f895839ac78ac6c$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $2f895839ac78ac6c$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
    $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.trans = trans;
        $2f895839ac78ac6c$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $2f895839ac78ac6c$var$keys(globalSchema).forEach(function(tableName) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else $2f895839ac78ac6c$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
    });
}
function $2f895839ac78ac6c$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $2f895839ac78ac6c$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $2f895839ac78ac6c$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $2f895839ac78ac6c$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $2f895839ac78ac6c$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $2f895839ac78ac6c$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $2f895839ac78ac6c$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $2f895839ac78ac6c$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $2f895839ac78ac6c$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $2f895839ac78ac6c$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $2f895839ac78ac6c$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $2f895839ac78ac6c$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $2f895839ac78ac6c$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto && !$2f895839ac78ac6c$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $2f895839ac78ac6c$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $2f895839ac78ac6c$var$addIndex(store, idx);
    });
    return store;
}
function $2f895839ac78ac6c$var$createMissingTables(newSchema, idbtrans) {
    $2f895839ac78ac6c$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $2f895839ac78ac6c$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $2f895839ac78ac6c$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $2f895839ac78ac6c$var$createIndexSpec($2f895839ac78ac6c$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $2f895839ac78ac6c$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $2f895839ac78ac6c$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $2f895839ac78ac6c$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    $2f895839ac78ac6c$var$setApiOnPlace(db, [
        db._allTables
    ], $2f895839ac78ac6c$var$keys(globalSchema), globalSchema);
}
function $2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $2f895839ac78ac6c$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $2f895839ac78ac6c$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + $2f895839ac78ac6c$var$slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $2f895839ac78ac6c$var$_global.WorkerGlobalScope && $2f895839ac78ac6c$var$_global instanceof $2f895839ac78ac6c$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $2f895839ac78ac6c$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return $2f895839ac78ac6c$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $2f895839ac78ac6c$var$isArray(keyPath), indexNum === 0);
    });
}
var $2f895839ac78ac6c$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $2f895839ac78ac6c$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $2f895839ac78ac6c$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $2f895839ac78ac6c$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $2f895839ac78ac6c$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $2f895839ac78ac6c$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $2f895839ac78ac6c$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $2f895839ac78ac6c$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $2f895839ac78ac6c$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $2f895839ac78ac6c$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $2f895839ac78ac6c$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $2f895839ac78ac6c$var$keys(dbschema), dbschema);
        db._storeNames = $2f895839ac78ac6c$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $2f895839ac78ac6c$var$promisableChain(this._cfg.contentUpgrade || $2f895839ac78ac6c$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $2f895839ac78ac6c$var$createVersionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $2f895839ac78ac6c$export$4ece27d405df7279($2f895839ac78ac6c$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $2f895839ac78ac6c$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $2f895839ac78ac6c$var$DBNAMES_DB;
        });
    }) : $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $2f895839ac78ac6c$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$vip(fn) {
    return $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.letThrough = true;
        return fn();
    });
}
function $2f895839ac78ac6c$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $2f895839ac78ac6c$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $2f895839ac78ac6c$var$rejection(state.dbOpenError) : db;
    });
    $2f895839ac78ac6c$var$debug && (state.openCanceller._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
            if (!req) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
            req.onblocked = $2f895839ac78ac6c$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $2f895839ac78ac6c$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $2f895839ac78ac6c$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $2f895839ac78ac6c$var$wrap(function() {
                        reject(new $2f895839ac78ac6c$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                    });
                } else {
                    upgradeTransaction.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db._novip.idbdb = req.result;
                    $2f895839ac78ac6c$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db._novip.idbdb = req.result;
                var objectStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($2f895839ac78ac6c$var$safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) $2f895839ac78ac6c$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                    }
                    $2f895839ac78ac6c$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $2f895839ac78ac6c$var$connections.push(db);
                idbdb.onversionchange = $2f895839ac78ac6c$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $2f895839ac78ac6c$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $2f895839ac78ac6c$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            if (err && err.name === 'UnknownError' && state.PR1398_maxLoop > 0) {
                state.PR1398_maxLoop--;
                console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                return tryOpenDB();
            } else return $2f895839ac78ac6c$var$DexiePromise.reject(err);
        });
    };
    return $2f895839ac78ac6c$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? $2f895839ac78ac6c$var$DexiePromise.resolve() : $2f895839ac78ac6c$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($2f895839ac78ac6c$var$promisableChain, $2f895839ac78ac6c$var$nop);
                state.onReadyBeingFired = [];
                return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $2f895839ac78ac6c$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $2f895839ac78ac6c$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? $2f895839ac78ac6c$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $2f895839ac78ac6c$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $2f895839ac78ac6c$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $2f895839ac78ac6c$var$DexiePromise.resolve().then(function() {
        var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = $2f895839ac78ac6c$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$pad(a, value, count) {
    var result = $2f895839ac78ac6c$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $2f895839ac78ac6c$var$createVirtualIndexMiddleware(down) {
    return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $2f895839ac78ac6c$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $2f895839ac78ac6c$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $2f895839ac78ac6c$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                schema: $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($2f895839ac78ac6c$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($2f895839ac78ac6c$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $2f895839ac78ac6c$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $2f895839ac78ac6c$var$createVirtualIndexMiddleware
};
function $2f895839ac78ac6c$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    $2f895839ac78ac6c$var$keys(a).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                var apTypeName = $2f895839ac78ac6c$var$toStringTag(ap);
                var bpTypeName = $2f895839ac78ac6c$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') $2f895839ac78ac6c$var$getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $2f895839ac78ac6c$var$keys(b).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $2f895839ac78ac6c$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === $2f895839ac78ac6c$var$nop && updating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                            var keys = req.keys || $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                keys: keys
                            }) : $2f895839ac78ac6c$var$__assign({}, req);
                            if (req.type !== 'delete') req.values = $2f895839ac78ac6c$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $2f895839ac78ac6c$var$__spreadArray([], req.keys, true);
                            return $2f895839ac78ac6c$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $2f895839ac78ac6c$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $2f895839ac78ac6c$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($2f895839ac78ac6c$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $2f895839ac78ac6c$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $2f895839ac78ac6c$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $2f895839ac78ac6c$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($2f895839ac78ac6c$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $2f895839ac78ac6c$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $2f895839ac78ac6c$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $2f895839ac78ac6c$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $2f895839ac78ac6c$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $2f895839ac78ac6c$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $2f895839ac78ac6c$var$_a;
function $2f895839ac78ac6c$var$isEmptyRange(node) {
    return !("from" in node);
}
var $2f895839ac78ac6c$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $2f895839ac78ac6c$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $2f895839ac78ac6c$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $2f895839ac78ac6c$var$extend(rv, fromOrTree);
        return rv;
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$export$34cb5241245008dd.prototype, ($2f895839ac78ac6c$var$_a = {
    add: function(rangeSet) {
        $2f895839ac78ac6c$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $2f895839ac78ac6c$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $2f895839ac78ac6c$var$addRange(_this, key, key);
        });
        return this;
    }
}, $2f895839ac78ac6c$var$_a[$2f895839ac78ac6c$var$iteratorSymbol] = function() {
    return $2f895839ac78ac6c$var$getRangeSetIterator(this);
}, $2f895839ac78ac6c$var$_a));
function $2f895839ac78ac6c$var$addRange(target, from, to) {
    var diff = $2f895839ac78ac6c$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($2f895839ac78ac6c$var$isEmptyRange(target)) return $2f895839ac78ac6c$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($2f895839ac78ac6c$var$cmp(to, target.from) < 0) {
        left ? $2f895839ac78ac6c$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.to) > 0) {
        right ? $2f895839ac78ac6c$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($2f895839ac78ac6c$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $2f895839ac78ac6c$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $2f895839ac78ac6c$export$4876cc3130d3f820(target, right);
}
function $2f895839ac78ac6c$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $2f895839ac78ac6c$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$2f895839ac78ac6c$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $2f895839ac78ac6c$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($2f895839ac78ac6c$var$cmp(b.from, a.to) <= 0 && $2f895839ac78ac6c$var$cmp(b.to, a.from) >= 0) return true;
        $2f895839ac78ac6c$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $2f895839ac78ac6c$var$getRangeSetIterator(node) {
    var state = $2f895839ac78ac6c$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $2f895839ac78ac6c$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $2f895839ac78ac6c$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $2f895839ac78ac6c$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $2f895839ac78ac6c$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $2f895839ac78ac6c$var$computeDepth(rootClone);
    }
    target.d = $2f895839ac78ac6c$var$computeDepth(target);
}
function $2f895839ac78ac6c$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $2f895839ac78ac6c$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $2f895839ac78ac6c$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, core), {
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    mutate: function(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($2f895839ac78ac6c$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $2f895839ac78ac6c$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $2f895839ac78ac6c$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $2f895839ac78ac6c$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $2f895839ac78ac6c$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $2f895839ac78ac6c$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($2f895839ac78ac6c$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $2f895839ac78ac6c$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $2f895839ac78ac6c$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $2f895839ac78ac6c$var$nop,
            dbReadyPromise: null,
            cancelOpen: $2f895839ac78ac6c$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $2f895839ac78ac6c$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $2f895839ac78ac6c$var$promisableChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
        this.on.ready.subscribe = $2f895839ac78ac6c$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $2f895839ac78ac6c$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $2f895839ac78ac6c$var$createCollectionConstructor(this);
        this.Table = $2f895839ac78ac6c$var$createTableConstructor(this);
        this.Transaction = $2f895839ac78ac6c$var$createTransactionConstructor(this);
        this.Version = $2f895839ac78ac6c$var$createVersionConstructor(this);
        this.WhereClause = $2f895839ac78ac6c$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $2f895839ac78ac6c$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $2f895839ac78ac6c$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($2f895839ac78ac6c$var$virtualIndexMiddleware);
        this.use($2f895839ac78ac6c$var$hooksMiddleware);
        this.use($2f895839ac78ac6c$var$observabilityMiddleware);
        this.use($2f895839ac78ac6c$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $2f895839ac78ac6c$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $2f895839ac78ac6c$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($2f895839ac78ac6c$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $2f895839ac78ac6c$var$PSD.letThrough || this._vip) ? fn() : new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($2f895839ac78ac6c$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $2f895839ac78ac6c$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $2f895839ac78ac6c$var$connections.indexOf(this);
        if (idx >= 0) $2f895839ac78ac6c$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $2f895839ac78ac6c$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype.delete = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                    $2f895839ac78ac6c$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $2f895839ac78ac6c$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $2f895839ac78ac6c$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $2f895839ac78ac6c$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $2f895839ac78ac6c$var$READONLY) idbMode = $2f895839ac78ac6c$var$READONLY;
            else if (mode == "rw" || mode == $2f895839ac78ac6c$var$READWRITE) idbMode = $2f895839ac78ac6c$var$READWRITE;
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $2f895839ac78ac6c$var$READONLY && idbMode === $2f895839ac78ac6c$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $2f895839ac78ac6c$var$rejection(e);
        }
        var enterTransaction = $2f895839ac78ac6c$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$2f895839ac78ac6c$var$hasOwn(this._allTables, tableName)) throw new $2f895839ac78ac6c$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $2f895839ac78ac6c$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $2f895839ac78ac6c$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$2f895839ac78ac6c$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $2f895839ac78ac6c$var$extendObservabilitySet(target, newSet) {
    $2f895839ac78ac6c$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
        $2f895839ac78ac6c$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $2f895839ac78ac6c$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $2f895839ac78ac6c$var$Observable(function(observer) {
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
            var exec = function() {
                return $2f895839ac78ac6c$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($2f895839ac78ac6c$var$decrementExpectedAwaits, $2f895839ac78ac6c$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                closed = true;
                $2f895839ac78ac6c$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $2f895839ac78ac6c$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $2f895839ac78ac6c$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function(parts) {
            $2f895839ac78ac6c$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $2f895839ac78ac6c$var$domDeps;
try {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: $2f895839ac78ac6c$var$_global.indexedDB || $2f895839ac78ac6c$var$_global.mozIndexedDB || $2f895839ac78ac6c$var$_global.webkitIndexedDB || $2f895839ac78ac6c$var$_global.msIndexedDB,
        IDBKeyRange: $2f895839ac78ac6c$var$_global.IDBKeyRange || $2f895839ac78ac6c$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $2f895839ac78ac6c$var$Dexie = $2f895839ac78ac6c$export$4ece27d405df7279;
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$Dexie, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, $2f895839ac78ac6c$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $2f895839ac78ac6c$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $2f895839ac78ac6c$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $2f895839ac78ac6c$var$getDatabaseNames($2f895839ac78ac6c$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $2f895839ac78ac6c$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $2f895839ac78ac6c$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $2f895839ac78ac6c$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(typeof promiseOrFunction === 'function' ? $2f895839ac78ac6c$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $2f895839ac78ac6c$var$DexiePromise,
    debug: {
        get: function() {
            return $2f895839ac78ac6c$var$debug;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$setDebug(value, value === 'dexie' ? function() {
                return true;
            } : $2f895839ac78ac6c$var$dexieStackFrameFilter);
        }
    },
    derive: $2f895839ac78ac6c$var$derive,
    extend: $2f895839ac78ac6c$var$extend,
    props: $2f895839ac78ac6c$var$props,
    override: $2f895839ac78ac6c$var$override,
    Events: $2f895839ac78ac6c$var$Events,
    on: $2f895839ac78ac6c$var$globalEvents,
    liveQuery: $2f895839ac78ac6c$export$6a9705d8f6f38796,
    extendObservabilitySet: $2f895839ac78ac6c$var$extendObservabilitySet,
    getByKeyPath: $2f895839ac78ac6c$var$getByKeyPath,
    setByKeyPath: $2f895839ac78ac6c$var$setByKeyPath,
    delByKeyPath: $2f895839ac78ac6c$var$delByKeyPath,
    shallowClone: $2f895839ac78ac6c$var$shallowClone,
    deepClone: $2f895839ac78ac6c$var$deepClone,
    getObjectDiff: $2f895839ac78ac6c$var$getObjectDiff,
    cmp: $2f895839ac78ac6c$var$cmp,
    asap: $2f895839ac78ac6c$var$asap$1,
    minKey: $2f895839ac78ac6c$var$minKey,
    addons: [],
    connections: $2f895839ac78ac6c$var$connections,
    errnames: $2f895839ac78ac6c$var$errnames,
    dependencies: $2f895839ac78ac6c$var$domDeps,
    semVer: $2f895839ac78ac6c$var$DEXIE_VERSION,
    version: $2f895839ac78ac6c$var$DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$2f895839ac78ac6c$var$Dexie.maxKey = $2f895839ac78ac6c$var$getMaxKey($2f895839ac78ac6c$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) {
            var event_1;
            if ($2f895839ac78ac6c$var$isIEOrEdge) {
                event_1 = document.createEvent('CustomEvent');
                event_1.initCustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $2f895839ac78ac6c$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $2f895839ac78ac6c$var$propagatingLocally = false;
        }
    });
    addEventListener($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$propagateLocally(detail);
    });
}
function $2f895839ac78ac6c$var$propagateLocally(updateParts) {
    var wasMe = $2f895839ac78ac6c$var$propagatingLocally;
    try {
        $2f895839ac78ac6c$var$propagatingLocally = true;
        $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $2f895839ac78ac6c$var$propagatingLocally = wasMe;
    }
}
var $2f895839ac78ac6c$var$propagatingLocally = false;
if (typeof BroadcastChannel !== 'undefined') {
    var $2f895839ac78ac6c$var$bc_1 = new BroadcastChannel($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $2f895839ac78ac6c$var$bc_1.unref === 'function') $2f895839ac78ac6c$var$bc_1.unref();
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$bc_1.postMessage(changedParts);
    });
    $2f895839ac78ac6c$var$bc_1.onmessage = function(ev) {
        if (ev.data) $2f895839ac78ac6c$var$propagateLocally(ev.data);
    };
} else if (typeof self !== 'undefined' && typeof navigator !== 'undefined') {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$2f895839ac78ac6c$var$propagatingLocally) {
                if (typeof localStorage !== 'undefined') localStorage.setItem($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self['clients'] === 'object') $2f895839ac78ac6c$var$__spreadArray([], self['clients'].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== 'undefined') addEventListener('storage', function(ev) {
        if (ev.key === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
        }
    });
    var $2f895839ac78ac6c$var$swContainer = self.document && navigator.serviceWorker;
    if ($2f895839ac78ac6c$var$swContainer) $2f895839ac78ac6c$var$swContainer.addEventListener('message', $2f895839ac78ac6c$var$propagateMessageLocally);
}
function $2f895839ac78ac6c$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
}
$2f895839ac78ac6c$var$DexiePromise.rejectionMapper = $2f895839ac78ac6c$var$mapError;
$2f895839ac78ac6c$var$setDebug($2f895839ac78ac6c$var$debug, $2f895839ac78ac6c$var$dexieStackFrameFilter);


class $d0d82807cb6e4dd6$export$a894a1a450ca79a4 extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    static active_profile_key = "profile.active";
    static balance_update_time_key = "job.balance_update";
    static instance = new $d0d82807cb6e4dd6$export$a894a1a450ca79a4();
    /*
        The properties are populated dynamically, the actual table
        structure is determined by the schema given to the `.stores` call in
        the constructor. Make sure that the properties and the schema
        passed in the constructor are in sync.
     */ /**
     * We use the settings table as a generic key/value storage.
     */ settings;
    constructor(){
        super("AppDatabase");
        this.version(1).stores({
            settings: ''
        });
    }
}


const { base_api_url: $616b048142acea2d$var$base_api_url, default_room: $616b048142acea2d$var$default_room, features: $616b048142acea2d$var$features } = (0, $03718d3379a37d9e$export$2e2bcd8739ae039);
/**
 * The active backed
 */ const $616b048142acea2d$var$backend = $616b048142acea2d$var$features.cli_backend ? $61eff7957713c367$exports : $64c315428a4a72bb$exports;
var $616b048142acea2d$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus[AccessStatus["StregsystemUnavailable"] = 0] = "StregsystemUnavailable";
    AccessStatus[AccessStatus["StregsystemAvailable"] = 1] = "StregsystemAvailable";
    AccessStatus[AccessStatus["ApiAvailable"] = 2] = "ApiAvailable";
    return AccessStatus;
}({});
const $616b048142acea2d$export$950dad61137d89af = ()=>fetch(`${$616b048142acea2d$var$base_api_url}/../${$616b048142acea2d$var$default_room}`).if((res)=>res.status === 200, 1).then_if_async((state)=>fetch(`${$616b048142acea2d$var$base_api_url}/products/active_products?room_id=${$616b048142acea2d$var$default_room}`).if((res)=>res.status === 200, 2).else_use(state)).else_promise(0).catch((err)=>{
        console.log("Stregsystem access check failed.");
        console.log(err);
        return 0;
    });
const $616b048142acea2d$export$8f57da2f1c7d25c = async (username)=>{
    const user_id = await $616b048142acea2d$var$backend.get_member_id(username);
    const { name: name, active: active, balance: balance } = await $616b048142acea2d$var$backend.get_member_info(user_id);
    return {
        username: username,
        id: user_id,
        name: name,
        active: active,
        balance: balance
    };
};
/*
    UI / HTML Elements
 */ const $616b048142acea2d$var$load_saved_profile = ()=>(0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).instance.settings.get((0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).active_profile_key).then((profile)=>{
        if (profile == null) return Promise.reject(`Key \`${(0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).active_profile_key}\` not found.`);
        $616b048142acea2d$export$4bf9923669ad6c63.profile_loaded.dispatch(profile);
        return profile;
    });
const $616b048142acea2d$export$4bf9923669ad6c63 = {
    ready: new (0, $d65da55d02f5d4e6$export$41ed841bd6096947)("stregsystem_ready"),
    access_update: new (0, $d65da55d02f5d4e6$export$41ed841bd6096947)("access_status"),
    profile_loaded: new (0, $d65da55d02f5d4e6$export$41ed841bd6096947)("profile_loaded"),
    profile_balance_change: new (0, $d65da55d02f5d4e6$export$41ed841bd6096947)("profile_balance_change")
};
/**
 * Formats a stregdollar price value as `XX.XX kr`
 * @param value
 */ const $616b048142acea2d$var$format_stregdollar = (value)=>`${(value / 100).toFixed(2)} kr`;
/**
 * Custom HTML element class for element `<fa-streg-product>`.
 * Represents a stregsystem product.
 */ class $616b048142acea2d$var$FaStregProduct extends HTMLElement {
    target_cart;
    decrement_btn;
    product_id;
    price;
    name;
    constructor(target, product_id, name, price){
        super();
        this.target_cart = target;
        this.product_id = product_id;
        this.price = price;
        this.name = name;
        this.innerHTML = `${name}<span>${$616b048142acea2d$var$format_stregdollar(price)} <button class="dec">-</button></span>`;
        this.decrement_btn = this.querySelector('.dec');
        this.decrement_btn.style.display = 'none';
        (0, $3gJDb.pointer_events)(this.decrement_btn, {
            n_click: this.removeFromCart.bind(this),
            stop_propagation: true
        });
        (0, $3gJDb.pointer_events)(this, {
            click: this.addToCart.bind(this),
            hold: [
                800,
                this.purchaseSingle.bind(this)
            ]
        });
    }
    async purchaseSingle() {
        if (confirm(`Do you want to purchase 1 x ${this.name} for ${$616b048142acea2d$var$format_stregdollar(this.price)}`)) {
            const { profile: profile } = this.target_cart.owner;
            if (profile.balance < this.price) {
                alert("You cannot afford this purchase. It will be cancelled.");
                return;
            }
            (0, $3gJDb.enable_loading_indicator)(true);
            try {
                await $616b048142acea2d$var$backend.post_sale(`${profile.username} ${this.product_id}`, $616b048142acea2d$var$default_room, profile.id);
                const new_balance = await $616b048142acea2d$var$backend.get_member_balance(profile.id);
                $616b048142acea2d$export$4bf9923669ad6c63.profile_balance_change.dispatch({
                    old_balance: profile.balance,
                    new_balance: new_balance
                });
            } catch (err) {
                alert("Purchase failed.");
                console.error(err);
            } finally{
                (0, $3gJDb.disable_loading_indicator)();
            }
        }
    }
    removeFromCart(_, bounces) {
        const cart_contents = this.target_cart.contents;
        if (bounces === 0) cart_contents[this.product_id] -= 1 + bounces;
        else if (bounces >= 2) cart_contents[this.product_id] = 0;
        if (cart_contents[this.product_id] === 0) {
            delete cart_contents[this.product_id];
            this.decrement_btn.style.display = 'none';
        }
        this.target_cart.update();
    }
    addToCart() {
        const cart_contents = this.target_cart.contents;
        if (cart_contents[this.product_id] == null) {
            cart_contents[this.product_id] = 1;
            this.decrement_btn.style.display = '';
        } else cart_contents[this.product_id] += 1;
        this.target_cart.update();
    }
}
class $616b048142acea2d$var$FaStregCart extends HTMLElement {
    owner;
    dialog;
    contents = {};
    last_update;
    product_counter;
    total_display;
    constructor(owner){
        super();
        this.owner = owner;
        this.product_counter = (0, $3gJDb.text)('');
        this.total_display = (0, $3gJDb.text)('', 'span');
        this.update();
        const product_count = (0, $3gJDb.text)('Items: ', 'span');
        product_count.append(this.product_counter);
        this.dialog = new $616b048142acea2d$var$FaStregCartDialog(this);
        this.append(product_count, this.total_display, this.dialog);
        (0, $3gJDb.pointer_events)(this, {
            click: this.on_click.bind(this),
            hold: [
                800,
                this.on_hold.bind(this),
                this.on_release.bind(this)
            ]
        });
    }
    async on_click() {
        const response = await this.dialog.show();
        if (response !== "confirm" || Object.keys(this.contents).length === 0) return;
        const { profile: profile } = this.owner;
        const buy_string = this.get_buy_string(profile.username);
        (0, $3gJDb.enable_loading_indicator)(true);
        try {
            await $616b048142acea2d$var$backend.post_sale(buy_string, $616b048142acea2d$var$default_room, profile.id);
            const new_balance = await $616b048142acea2d$var$backend.get_member_balance(profile.id);
            $616b048142acea2d$export$4bf9923669ad6c63.profile_balance_change.dispatch({
                old_balance: profile.balance,
                new_balance: new_balance
            });
            this.contents = {};
            this.update();
            this.owner.querySelectorAll('.dec').forEach((e)=>e.style.display = 'none');
        } catch (e) {
            alert("Purchase failed.");
            console.error(e);
        }
        (0, $3gJDb.disable_loading_indicator)();
    }
    on_hold() {
        this.dialog.open_preview();
    }
    on_release() {
        this.dialog.close_preview();
    }
    /**
     * Updates the HTML dom to reflect the current internal state.
     */ update() {
        this.last_update = Date.now();
        this.product_counter.textContent = this.compute_product_count().toString();
        this.total_display.innerText = $616b048142acea2d$var$format_stregdollar(this.compute_total());
        this.owner.querySelectorAll('fa-streg-product').forEach((e)=>{});
    }
    /**
     * Compute the total value of the carts contents.
     */ compute_total() {
        return Object.keys(this.contents).map((id)=>this.owner.catalogue[id].price * this.contents[id]).reduce((0, $3gJDb.reduce_sum), 0);
    }
    /**
     * Compute the number of items in the cart.
     */ compute_product_count() {
        return Object.keys(this.contents).map((key)=>this.contents[key]).reduce((0, $3gJDb.reduce_sum), 0);
    }
    /**
     * Convert the cart contents into a stregsystem multibuy string.
     */ get_buy_string(username) {
        const a = Object.keys(this.contents).filter((key)=>this.contents[key] > 0).map((key)=>`${key}:${this.contents[key]}`).join(' ');
        return `${username} ${a}`;
    }
}
class $616b048142acea2d$var$FaStregCartDialog extends HTMLElement {
    cart;
    dialog;
    table;
    last_update;
    constructor(cart){
        super();
        this.setAttribute("mode", "hidden");
        this.cart = cart;
        const table = document.createElement('table');
        const head = document.createElement('thead');
        const h_row = document.createElement('tr');
        h_row.append((0, $3gJDb.text)('product', 'td'), (0, $3gJDb.text)('count', 'td'), (0, $3gJDb.text)('price', 'td'), (0, $3gJDb.text)('total', 'td'));
        head.append(h_row);
        this.table = document.createElement('tbody');
        table.append(head, this.table);
        this.dialog = document.createElement('dialog');
        this.dialog.append(table);
        // Stop pointer event propagation past the model.
        // Also closes the model if the backdrop is clicked.
        this.dialog.addEventListener('pointerdown', function(e) {
            e.stopPropagation();
            const { left: left, right: right, top: top, bottom: bottom } = e.target.getBoundingClientRect();
            if (e.clientX < left || right < e.clientX || e.clientY < top || bottom < e.clientY) this.close();
        });
        const dialog_form = document.createElement('form');
        dialog_form.method = 'dialog';
        dialog_form.append((0, $3gJDb.text)('cancel', 'button'), (0, $3gJDb.text)('confirm', 'button'));
        dialog_form.children[0].value = "";
        dialog_form.children[1].value = "confirm";
        this.dialog.append(dialog_form);
        this.append(this.dialog);
    }
    confirm_purchase() {
        return new Promise((resolve)=>{
            const { dialog: dialog } = this;
            const cb = ()=>{
                dialog.removeEventListener('close', cb);
                resolve(dialog.returnValue);
            };
            dialog.addEventListener('close', cb);
            this.dialog.showModal();
        });
    }
    close_preview() {
        this.setAttribute("mode", "hidden");
        this.dialog.close("");
    }
    open_preview() {
        if (this.dialog.open) return;
        this.generate_table_contents();
        this.setAttribute("mode", "preview");
        this.dialog.show();
    }
    async show() {
        // This case typically occurs if the user taps the backdrop.
        // We just dismiss the modal when this happens.
        if (this.dialog.open) {
            this.dialog.close("");
            return "";
        }
        this.generate_table_contents();
        this.setAttribute("mode", "modal");
        const response = await this.confirm_purchase();
        this.setAttribute("mode", "hidden");
        return response;
    }
    generate_table_contents() {
        if (this.last_update === this.cart.last_update) return;
        this.last_update = this.cart.last_update;
        const { catalogue: catalogue, profile: profile } = this.cart.owner;
        const contents = (0, $3gJDb.as_tuples)(this.cart.contents);
        let product_rows;
        if (contents.length > 0) product_rows = contents.map(([id, count])=>{
            const row = document.createElement('tr');
            row.append((0, $3gJDb.text)(catalogue[id].name, 'td'), (0, $3gJDb.text)(count.toString(), 'td'), (0, $3gJDb.text)($616b048142acea2d$var$format_stregdollar(catalogue[id].price), 'td'), (0, $3gJDb.text)($616b048142acea2d$var$format_stregdollar(catalogue[id].price * count), 'td'));
            return row;
        });
        else {
            const row = document.createElement('tr');
            row.append((0, $3gJDb.text)('Your cart is empty!', 'td'));
            product_rows = [
                row
            ];
        }
        product_rows[0].classList.add('table-rule');
        const total = this.cart.compute_total();
        const summary_rows = [
            [
                "Total",
                total
            ],
            [
                "New Balance",
                profile.balance - total
            ]
        ].map(([label, price])=>{
            const row = document.createElement('tr');
            row.append((0, $3gJDb.text)(label, 'td'), (0, $3gJDb.text)('', 'td'), (0, $3gJDb.text)('', 'td'), (0, $3gJDb.text)($616b048142acea2d$var$format_stregdollar(price), 'td'));
            return row;
        });
        summary_rows[0].classList.add('table-rule');
        this.table.innerHTML = '';
        this.table.append(...product_rows, ...summary_rows);
    }
}
/**
 * HTML element used to display profile information in the header.
 * Defines the custom element `<fa-profile-widget>`.
 */ class $616b048142acea2d$var$FaProfileWidget extends HTMLElement {
    profile;
    balance;
    username;
    constructor(){
        super();
        $616b048142acea2d$export$4bf9923669ad6c63.profile_loaded.register_handle(this.on_profile_load, this);
        $616b048142acea2d$export$4bf9923669ad6c63.profile_balance_change.register_handle(this.on_balance_change, this);
        this.balance = document.createTextNode("");
        this.username = document.createTextNode("");
        this.append(this.username, document.createElement('br'), this.balance);
        (0, $3gJDb.pointer_events)(this, {
            hold: [
                800,
                this.logout.bind(this)
            ]
        });
        window.addEventListener('focus', ()=>{
            const now = Date.now();
            if ($616b048142acea2d$var$last_balance_bg_update - now > 5000) this.update_balance(now);
        });
    }
    on_profile_load(profile) {
        this.profile = profile;
        this.username.textContent = profile.username;
        this.balance.textContent = $616b048142acea2d$var$format_stregdollar(profile.balance);
        setTimeout(()=>this.balance_update_job(), 10000);
    }
    async logout() {
        await (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).instance.settings.delete("profile.active");
        window.location.reload();
    }
    on_balance_change(change) {
        this.balance.textContent = $616b048142acea2d$var$format_stregdollar(change.new_balance);
    }
    async update_balance(now) {
        const balance = await $616b048142acea2d$var$backend.get_member_balance(this.profile.id);
        $616b048142acea2d$var$last_balance_bg_update = now;
        await (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).instance.settings.put(now, (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).balance_update_time_key);
        $616b048142acea2d$export$4bf9923669ad6c63.profile_balance_change.dispatch({
            old_balance: this.profile.balance,
            new_balance: balance
        });
    }
    async balance_update_job() {
        const now = Date.now();
        if (now - $616b048142acea2d$var$last_balance_bg_update >= 10000) await this.update_balance(now);
        setTimeout(()=>this.balance_update_job(), 10000);
    }
}
class $616b048142acea2d$var$FaStregsystem extends HTMLElement {
    profile;
    catalogue;
    cart;
    constructor(){
        super();
        console.log("initiating stregsystem module");
        $616b048142acea2d$export$4bf9923669ad6c63.ready.register_handle(this.on_ready, this);
        $616b048142acea2d$export$4bf9923669ad6c63.profile_loaded.register_handle(this.on_profile_loaded, this);
        $616b048142acea2d$export$4bf9923669ad6c63.profile_balance_change.register_handle(this.on_profile_balance_change, this);
        $616b048142acea2d$export$4bf9923669ad6c63.access_update.register_handle(this.on_access_status, this);
        this.cart = new $616b048142acea2d$var$FaStregCart(this);
    }
    on_ready() {
        if (this.profile == null) this.render_profile_prompt();
        else this.render_catalogue(this.profile);
    }
    on_profile_loaded(profile) {
        this.profile = profile;
    }
    on_profile_balance_change(change) {
        this.profile.balance = change.new_balance;
    }
    /**
     * This is executed when the access status is updated.
     * @param status
     */ on_access_status(status) {
        if (status === 0) {
            console.log("unable to connect to stregsystem");
            this.classList.add('flex-center', 'center');
            this.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($7fda80fa9598ab09$exports)));
        } else if (status !== 2 && $616b048142acea2d$var$backend === $64c315428a4a72bb$exports) {
            console.log("target stregsystem instance does not have API support");
            this.classList.add('flex-center', 'center');
            this.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($18ca72d7af810590$exports)));
        }
    }
    async render_catalogue(_) {
        this.innerHTML = '';
        const product_container = document.createElement('div');
        product_container.classList.add("border-outer");
        this.catalogue = await $616b048142acea2d$var$backend.get_active_products($616b048142acea2d$var$default_room);
        const product_elements = Object.keys(this.catalogue).map((key)=>new $616b048142acea2d$var$FaStregProduct(this.cart, parseInt(key), this.catalogue[key].name, this.catalogue[key].price));
        product_container.append(...product_elements);
        this.append("Individual items can be purchased by pressing and holding on a product.", product_container, this.cart);
        (0, $3gJDb.disable_loading_indicator)();
    }
    render_profile_prompt() {
        const prompt_msg = 'In order to use stregsystemet you must first select the account that you will be using.';
        this.classList.add('profile-prompt');
        this.innerText = prompt_msg;
        const name_input = document.createElement('input');
        name_input.placeholder = 'Username';
        const submit_button = document.createElement('button');
        submit_button.innerText = 'Submit';
        submit_button.addEventListener('click', (0, $3gJDb.void_promise)(async ()=>{
            if (name_input.value.length === 0) return;
            this.style.display = 'none';
            (0, $3gJDb.enable_loading_indicator)();
            const name = name_input.value;
            try {
                const profile = await $616b048142acea2d$export$8f57da2f1c7d25c(name);
                await (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).instance.settings.put(profile, (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).active_profile_key);
                $616b048142acea2d$export$4bf9923669ad6c63.profile_loaded.dispatch(profile);
                this.classList.remove('profile-prompt');
                await this.render_catalogue(profile);
            } catch (_) {
                this.childNodes[0].nodeValue = `${prompt_msg} Unable to find user by name "${name}".`;
                (0, $3gJDb.disable_loading_indicator)();
            }
            this.style.display = '';
        }));
        this.append(name_input, submit_button);
        (0, $3gJDb.disable_loading_indicator)();
    }
}
let $616b048142acea2d$var$last_balance_bg_update;
const $616b048142acea2d$export$2cd8252107eb640b = async ()=>{
    customElements.define("fa-streg-product", $616b048142acea2d$var$FaStregProduct);
    customElements.define("fa-streg-cart", $616b048142acea2d$var$FaStregCart);
    customElements.define("fa-streg-cart-dialog", $616b048142acea2d$var$FaStregCartDialog);
    customElements.define("fa-stregsystem", $616b048142acea2d$var$FaStregsystem);
    customElements.define("fa-profile-widget", $616b048142acea2d$var$FaProfileWidget);
    $616b048142acea2d$var$last_balance_bg_update = await (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).instance.settings.get((0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).balance_update_time_key) | 0;
    await $616b048142acea2d$var$backend.init();
    $616b048142acea2d$export$4bf9923669ad6c63.profile_balance_change.register_handle(({ new_balance: new_balance })=>{
        (0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).instance.settings.update((0, $d0d82807cb6e4dd6$export$a894a1a450ca79a4).active_profile_key, {
            balance: new_balance
        });
    });
    $616b048142acea2d$var$load_saved_profile().finally(()=>{
        $616b048142acea2d$export$4bf9923669ad6c63.ready.dispatch(null);
    });
};




var $3gJDb = parcelRequire("3gJDb");
var $f516db72e21935b7$exports = {};
$f516db72e21935b7$exports = "<p class=center>Unable to connect to calendar API! 😦 <br>\nMake sure that you are connected to the Internet.";


const { events_api_url: $6c94057699823b25$var$events_api_url, events_api_key: $6c94057699823b25$var$events_api_key, events_id: $6c94057699823b25$var$events_id, events_base_url: $6c94057699823b25$var$events_base_url } = (0, $03718d3379a37d9e$export$2e2bcd8739ae039);
function $6c94057699823b25$var$get_dates_from_event(event) {
    let start;
    let end;
    if (event.start.dateTime === undefined) {
        start = new Date(new Date(event.start.date).toLocaleDateString("en", {
            timeZone: "America/New_York"
        }));
        start.setDate(start.getDate() + 1);
    } else start = new Date(event.start.dateTime);
    if (event.end.dateTime === undefined) {
        end = new Date(new Date(event.end.date).toLocaleDateString("en", {
            timeZone: "America/New_York"
        }));
        end.setDate(end.getDate() + 1);
    } else end = new Date(event.end.dateTime);
    return {
        start: start,
        end: end,
        created: event.created,
        updated: event.updated
    };
}
/**
 * Custom HTML element class for element `<fa-events>`.  
 * Represents a set of upcoming and past events
 */ class $6c94057699823b25$var$FaEvents extends HTMLElement {
    constructor(){
        super();
        let minTime = new Date();
        minTime.setMonth(minTime.getMonth() - 4);
        this.innerHTML = "";
        this.load({
            key: $6c94057699823b25$var$events_api_key,
            singleEvents: true,
            orderBy: "starttime",
            timeMin: minTime.toISOString()
        });
    }
    load(options) {
        let url = `${$6c94057699823b25$var$events_api_url}${$6c94057699823b25$var$events_id}/events`;
        let params = Object.keys(options).map((key)=>{
            if (options[key] !== undefined) return key + '=' + options[key];
        }).join('&');
        url += `?${params}`;
        fetch(url).then((res)=>{
            if (res.status === 200) res.json().then((res)=>this.render_events(res));
            else this.access_failure();
        }).catch((_)=>{
            this.access_failure();
        });
    }
    render_events(eventList) {
        let events = eventList.items.reverse();
        let current_date = new Date();
        (0, $3gJDb.disable_loading_indicator)();
        let upcoming = document.createElement("div");
        upcoming.className = "border-outer";
        let ongoing = document.createElement("div");
        ongoing.className = "border-outer";
        let past = document.createElement("div");
        past.className = "border-outer";
        for(let i = 0; i < events.length; i++){
            let event_dates = $6c94057699823b25$var$get_dates_from_event(events[i]);
            let element = document.createElement("p");
            element.className = "border-inner";
            let time_string = event_dates.start.toLocaleTimeString([], {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            element.innerText = `${time_string} - ${events[i].summary}`;
            if (event_dates.start < current_date && event_dates.end > current_date) ongoing.appendChild(element);
            else if (event_dates.start > current_date) upcoming.appendChild(element);
            else past.appendChild(element);
        }
        if (ongoing.children.length > 0) {
            let header = document.createElement("h2");
            header.innerText = "Ongoing";
            this.appendChild(header);
            this.appendChild(ongoing);
        }
        if (upcoming.children.length > 0) {
            let header = document.createElement("h2");
            header.innerText = "Upcoming";
            this.appendChild(header);
            this.appendChild(upcoming);
        }
        if (past.children.length > 0) {
            let header = document.createElement("h2");
            header.innerText = "Past";
            this.appendChild(header);
            this.appendChild(past);
        }
        let link = document.createElement("a");
        link.href = `${$6c94057699823b25$var$events_base_url}${$6c94057699823b25$var$events_id}`;
        link.innerText = "Add to calendar";
        this.appendChild(link);
    }
    access_failure() {
        this.classList.add('flex-center', 'center');
        this.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($f516db72e21935b7$exports)));
    }
}
const $6c94057699823b25$export$2cd8252107eb640b = ()=>{
    customElements.define("fa-events", $6c94057699823b25$var$FaEvents);
};



function $44718417e850519b$var$update_status_indicator(status) {
    const elements = document.querySelectorAll('.access-status-indicator');
    if (status === (0, $616b048142acea2d$export$9d38595f26d62a61).StregsystemUnavailable) elements?.forEach((node)=>{
        node.classList.add("offline");
        node.classList.remove("online", "partial");
    });
    else elements?.forEach((node)=>{
        node.classList.remove("offline", "online", "partial");
        node.classList.add(status === (0, $616b048142acea2d$export$9d38595f26d62a61).ApiAvailable ? "online" : "partial");
    });
}
async function $44718417e850519b$var$event_online() {
    const access_status = await $616b048142acea2d$export$950dad61137d89af();
    $616b048142acea2d$export$4bf9923669ad6c63.access_update.dispatch(access_status);
}
function $44718417e850519b$var$event_offline() {
    $616b048142acea2d$export$4bf9923669ad6c63.access_update.dispatch((0, $616b048142acea2d$export$9d38595f26d62a61).StregsystemUnavailable);
}
function $44718417e850519b$var$toggle_sidebar() {
    const sidebar = document.getElementById("sidebar-nav");
    if (sidebar == null) {
        console.error('Sidebar not found. Unable to toggle.');
        return;
    }
    if (sidebar.classList.contains('active')) sidebar.classList.remove('active');
    else sidebar.classList.add('active');
}
function $44718417e850519b$var$init_tenfoot_navigation() {
    if (!document.documentElement.classList.contains('ten-foot')) return;
    const links = Array.from(document.querySelectorAll('.service-menu .service-link'));
    if (links.length === 0) return;
    document.addEventListener('keydown', (event)=>{
        if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLSelectElement) return;
        const current_index = links.indexOf(document.activeElement);
        let next_index;
        switch(event.key){
            case 'ArrowRight':
            case 'ArrowDown':
                next_index = current_index < 0 ? 0 : (current_index + 1) % links.length;
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                next_index = current_index < 0 ? links.length - 1 : (current_index - 1 + links.length) % links.length;
                break;
            case 'Home':
                next_index = 0;
                break;
            case 'End':
                next_index = links.length - 1;
                break;
        }
        if (next_index === undefined) return;
        event.preventDefault();
        links[next_index].focus();
        links[next_index].scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
        });
    });
    links[0].focus();
}
function $44718417e850519b$var$toggle_darkmode() {
    let theme = document.body.classList.toggle("dark-theme") ? "dark" : "light";
    localStorage.setItem("theme", theme);
}
var $b0cfc87112365479$exports = {};
$b0cfc87112365479$exports = import.meta.resolve("hVkq6");


/*
    Main function
 */ (()=>{
    if ("serviceWorker" in navigator && !document.disable_worker) {
        const worker = new URL($b0cfc87112365479$exports);
        navigator.serviceWorker.register(worker, {
            scope: "/"
        }).then(()=>{
            console.log("Service Worker Registered");
        });
    }
    console.log(`Running in ${(0, $03718d3379a37d9e$export$76e324a9f4eb4867) ? "production" : "development"} mode.`);
    if (!(0, $03718d3379a37d9e$export$76e324a9f4eb4867)) console.dir((0, $03718d3379a37d9e$export$2e2bcd8739ae039));
    // If the cli backend is enabled we initialise the
    // pyodide python runtime.
    if ((0, $03718d3379a37d9e$export$2e2bcd8739ae039).features.cli_backend) $b22d2393df1c17c8$export$2cd8252107eb640b();
    /*
        Navigation sidebar
     */ document.querySelectorAll('.nav-trigger')?.forEach((node)=>{
        node.addEventListener('click', $44718417e850519b$var$toggle_sidebar);
    });
    $44718417e850519b$var$init_tenfoot_navigation();
    /*
        Dark Mode stuff
    */ const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
    let currTheme = localStorage.getItem("theme");
    if (currTheme === null) currTheme = prefersDarkScheme.matches ? "dark" : "light";
    if (currTheme == "dark") document.body.classList.toggle("dark-theme");
    document.querySelectorAll('.darkmode-button')?.forEach((node)=>{
        node.addEventListener('click', $44718417e850519b$var$toggle_darkmode);
    });
    /*
        Connectivity checks
     */ window.addEventListener('online', ()=>void $44718417e850519b$var$event_online());
    window.addEventListener('offline', $44718417e850519b$var$event_offline);
    $616b048142acea2d$export$4bf9923669ad6c63.access_update.register_handle($44718417e850519b$var$update_status_indicator);
    if (navigator.onLine) $44718417e850519b$var$event_online();
    else $44718417e850519b$var$event_offline();
    /*
        Init modules
     */ $616b048142acea2d$export$2cd8252107eb640b();
    $6c94057699823b25$export$2cd8252107eb640b();
})();


//# sourceMappingURL=pages.24329946.js.map
